<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="350"
    height="325"
    id="milestone-docs"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 279.5 282.6"
    role="presentation"
    aria-labelledby="newdocs"
  >
    <title id="newdocs">New version of docs</title>
    <defs>
      <clipPath id="docscover" transform="translate(0 0.1)">
        <rect
          class="cls-1"
          x="-21.9"
          y="-12.4"
          width="308.3"
          height="234.15"
          transform="translate(66.6 -50.7) rotate(28.7)"
        />
      </clipPath>
    </defs>
    <path
      id="Shadow"
      class="cls-2"
      d="M58.2,133,255.9,246.5l-.4.6L57.8,133.6ZM56,134.3,253.8,247.6l-.4.7L55.6,134.9Zm-2,1.1L251.8,248.8l-.4.7L53.7,136Zm-2.2,1.2L249.5,250l-.4.6L51.4,137.2ZM50,137.9,247.7,251.3l-.3.6L49.6,138.5ZM47.7,139,245.5,252.5l-.4.6L47.4,139.7Zm-1.9,1.3L243.6,253.7l-.4.6L45.5,140.9Zm-2.2,1.2L241.3,254.9l-.3.6L43.2,142.1Zm-2,1.1L239.3,256.1l-.3.6L41.2,143.3Zm-2.3,1.2L237.1,257.2l-.4.6L39,144.4ZM37.5,145,235.2,258.5l-.4.6L37.1,145.6Zm-2.3,1.2L232.9,259.6l-.3.6L34.8,146.8Zm-1.9,1.3L231,260.9l-.3.6L33,148.1Zm-2.1,1.2L228.9,262.1l-.4.6L30.8,149.3Zm-2,1.2L226.9,263.3l-.3.6L28.8,150.5ZM26.9,151,224.7,264.4l-.4.7L26.6,151.6Zm39.8-22.7L264.4,241.7l-.3.7L66.3,128.9Zm-2.3,1.2L262.2,242.9l-.4.6L64.1,130.1Zm-1.9,1.2L260.3,244.1l-.4.6L62.2,131.3Zm-2.2,1.2L258,245.3l-.3.6L59.9,132.5Zm-2,1.2L256,246.6l-.4.6L57.9,133.8Zm18.4-10.8L274.5,235.7l-.4.6L76.4,122.9Zm-1.9,1.2L272.5,236.9l-.4.6L74.4,124.1Zm-2.3,1.1L270.2,238l-.3.7L72.1,125.2ZM70.7,126,268.4,239.4l-.3.6L70.3,126.6Zm-2.3,1.1L266.2,240.5l-.4.6L68.1,127.7Zm19-10.6,188,107.8-.3.6L87.1,117.1Zm-2.2,1.1,191,109.5-.4.6L84.9,118.2Zm-2,1.2L276.5,229.7l-.4.6L82.9,119.5Zm-2.3,1.1L276.4,232.1l-.3.6L80.6,120.6Zm-1.8,1.3L275.7,234l-.3.6L78.8,121.8ZM18.5,155.8,216.3,269.2l-.4.6L18.2,156.4ZM16.3,157,214,270.4l-.3.6L15.9,157.6Zm-2.1,1.2L212,271.7l-.4.6L13.9,158.9Zm-2.1,1.2L209.9,272.8l-.4.6L11.8,160Zm-1.9,1.2L208,274l-.4.7L9.9,161.2Zm-2.1,1.2L205.8,275.3l-.3.6L7.7,162.5ZM6,163.1,203.8,276.5l-.4.7L5.7,163.7Zm-2.2,1.1L201.6,277.6l-.4.6L3.5,164.8Zm-2,1.2L199.5,278.9l-.3.6L1.4,166.1ZM3,168.5,196.7,279.6l-.4.6L2.7,169.2ZM.9,169.7l193,110.7-.4.6L.5,170.3Zm-.3,2.2L191.2,281.3l-.3.6L.2,172.5Zm-.3,2.2,188,107.8-.4.6L0,174.7Zm.9,2.9L184.1,281.9l-.3.6L.8,177.6Zm.7,2.8L178.8,281.2l-.3.6L1.5,180.4ZM3.4,183l168.3,96.6-.3.6L3,183.6Zm21.4-30.8L222.6,265.7l-.4.6L24.5,152.9Zm-2,1.3L220.5,266.9l-.3.7L22.4,154.1Zm-2.3,1.2L218.2,268.1l-.3.6L20.1,155.3Zm-2,1.2L216.3,269.3l-.4.6L18.1,156.5Z"
      transform="translate(0 0.1)"
    />
    <g id="Illustration">
      <g id="Bars_2" data-name="Bars 2">
        <g id="Group">
          <g id="Group_2" data-name="Group 2">
            <path
              id="Vector"
              class="cls-3"
              d="M107.3,103.5V49.6L120,42.2V96.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_2"
              data-name="Vector 2"
              class="cls-4"
              d="M107.3,49.6,94.6,42.2V96.1l12.7,7.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_3"
              data-name="Vector 3"
              class="cls-5"
              d="M120,42.2l-12.7-7.3L94.6,42.2l12.7,7.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="Group_3" data-name="Group 3">
            <path
              id="Vector_4"
              data-name="Vector 4"
              class="cls-5"
              d="M120,106l-12.7-7.3v4.8l12.7,7.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="Group_4" data-name="Group 4">
            <path
              id="Vector_5"
              data-name="Vector 5"
              class="cls-5"
              d="M94.6,110.9V71.6l12.7-7.3v39.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_6"
              data-name="Vector 6"
              class="cls-5"
              d="M94.6,71.6,81.9,64.3v39.2l12.7,7.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_7"
              data-name="Vector 7"
              class="cls-5"
              d="M107.3,64.3,94.6,57,81.9,64.3l12.7,7.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_8"
              data-name="Vector 8"
              class="cls-3"
              d="M94.6,110.9V71.6l12.7-7.3v39.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_9"
              data-name="Vector 9"
              class="cls-4"
              d="M94.6,71.6,81.9,64.3v39.2l12.7,7.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_10"
              data-name="Vector 10"
              class="cls-5"
              d="M107.3,64.3,94.6,57,81.9,64.3l12.7,7.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="Group_5" data-name="Group 5">
            <path
              id="Vector_11"
              data-name="Vector 11"
              class="cls-3"
              d="M107.3,118.2V96.1L120,88.8v22.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_12"
              data-name="Vector 12"
              class="cls-4"
              d="M107.3,96.1,94.6,88.8v22.1l12.7,7.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_13"
              data-name="Vector 13"
              class="cls-5"
              d="M120,88.8l-12.7-7.3L94.6,88.8l12.7,7.3Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="Laptop">
        <path
          class="cls-6"
          d="M244,113.9v80.3a7.2,7.2,0,0,1-.6,2.9l1.1-.5c1-.7,1.6-2,1.6-4V112.3a5.7,5.7,0,0,0-.1-1.3l-2.2.9A13.6,13.6,0,0,1,244,113.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M246.9,110.3h0a15,15,0,0,0-1.5-4.2h0a28.3,28.3,0,0,0-2-2.8,10,10,0,0,0-2-1.6h-.1L143.6,45a4,4,0,0,0-3.8-.4L136.7,46h-.4c-1.4.8-2.2,2.5-2.2,4.8v80.6a14.7,14.7,0,0,0,4.3,9.7,12.5,12.5,0,0,0-7.8,1.4L65.1,180.4a5.5,5.5,0,0,0-2.8,3.5v4.7a2.8,2.8,0,0,0,1,2.4,3.1,3.1,0,0,0,1.1.9l1.7,1h.1l94.2,54.5a9.3,9.3,0,0,0,4.9,1.1h1.2l1.3-.2h.5l.9-.3h.6l.8-.4h.3l.7-.3L237,209.4c1.8-1.1,2.9-2.5,2.9-4v-4.3h-.1a2.8,2.8,0,0,0-.3-1.3h.6a3.3,3.3,0,0,0,1.7-.4h.2l3-1.5c1.4-.8,2.1-2.5,2.1-4.8V112.3A13.6,13.6,0,0,0,246.9,110.3Zm-.8,2v80.3c0,2-.6,3.3-1.6,4l-1.1.5a7.2,7.2,0,0,0,.6-2.9V113.9a13.6,13.6,0,0,0-.2-2l2.2-.9A5.7,5.7,0,0,1,246.1,112.3ZM141.2,142.9l96.1,55.6a2.9,2.9,0,0,1,1.3,1.4,4.3,4.3,0,0,1-2.1,2.3L171.1,240c-3,1.7-7.6,1.9-10.2.4l-96-55.6a3.2,3.2,0,0,1-1.4-1.4,5.6,5.6,0,0,1,2.1-2.2l65.5-37.8C134,141.7,138.6,141.5,141.2,142.9Zm21,104.1v-3.4l1.8.3h1.4a12.7,12.7,0,0,0,4.7-.9v3.5A11.9,11.9,0,0,1,162.2,247Zm74.3-43.3-65.4,37.9c-3,1.7-7.6,1.9-10.2.4l-96-55.5a2.8,2.8,0,0,1-1.5-1.5l1,.7,96,55.6c2.9,1.7,7.9,1.5,11.2-.4L237,203h0a5.8,5.8,0,0,0,1.5-1.1A5.8,5.8,0,0,1,236.5,203.7ZM65,191.1c-1.2-.7-1.7-1.5-1.6-2.4h0v-2l1,.7,1.5.9v3.4Zm1.9,1v-3.3l93.5,54.1h.2l.6.3v3.4H161Zm104.2,50.5.5-.2L237,204.6l.7-.5h.2l.5-.4v-.3l.4-.3v2c0,1.1-.9,2.3-2.4,3.2L171,246.1Zm67-44.8h0l-76.7-44.3-19.7-11.4h-.1l-1.1-.7c-2.9-1.7-5.4-6.3-5.4-10V51c0-1.9.6-3.3,1.7-3.9a2.7,2.7,0,0,1,1.2-.3,3.6,3.6,0,0,1,2,.6l97.6,56.5c2.9,1.6,5.4,6.2,5.4,10v80.3a4.5,4.5,0,0,1-1.7,3.9A3.1,3.1,0,0,1,238.1,197.8ZM140.3,45.5a3.1,3.1,0,0,1,2.8.4l97.7,56.4,1,.7-2.3,1-1.4-1L140.5,46.5l-1.3-.5.9-.4Zm103.2,65.4a12.9,12.9,0,0,0-3.2-6.1l2.3-1a12.9,12.9,0,0,1,3.2,6.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M140.5,46.5,238.1,103l1.4,1,2.3-1-1-.7L143.1,45.9a3.1,3.1,0,0,0-2.8-.4h-.2l-.9.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M242.6,103.8l-2.3,1a12.9,12.9,0,0,1,3.2,6.1l2.3-1A12.9,12.9,0,0,0,242.6,103.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M241.3,198.1a4.5,4.5,0,0,0,1.7-3.9V113.9c0-3.8-2.5-8.4-5.4-10L140,47.4a3.6,3.6,0,0,0-2-.6,2.7,2.7,0,0,0-1.2.3c-1.1.6-1.7,2-1.7,3.9v80.4c0,3.7,2.5,8.3,5.4,10l1.1.7h.1l19.7,11.4,76.7,44.3h0A3.1,3.1,0,0,0,241.3,198.1Zm-6.9-5.4-91.2-52.6c-3-1.8-5.3-6.2-5.3-10.1V56.5c0-2,.7-3.7,2-4.4a3.7,3.7,0,0,1,3.8.3L234.9,105c3,1.8,5.3,6.2,5.3,10v73.5c0,2.2-.7,3.8-2,4.5a2.8,2.8,0,0,1-1.5.4A4.8,4.8,0,0,1,234.4,192.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M238.2,193c1.3-.7,2-2.3,2-4.5V115c0-3.8-2.3-8.2-5.3-10L143.7,52.4a3.7,3.7,0,0,0-3.8-.3c-1.3.7-2,2.4-2,4.4V130c0,3.9,2.3,8.3,5.3,10.1l91.2,52.6a4.8,4.8,0,0,0,2.3.7A2.8,2.8,0,0,0,238.2,193Zm-38.1-78.2-4.1-2.3a1.6,1.6,0,0,1-.5-.9h0l4.1,2.4a1.1,1.1,0,0,1,.5.9Zm1.7,12.6h0l-12-6.9a1.6,1.6,0,0,1-.5-.9h0l12,6.9a1.1,1.1,0,0,1,.5.9Zm.8,19.4,6.8,4a1.1,1.1,0,0,1,.5.9h0l-6.8-3.9a1.1,1.1,0,0,1-.5-.9Zm-16.3-1.6,7,4a1.1,1.1,0,0,1,.5.9h0l-7-4.1a1.1,1.1,0,0,1-.5-.9Zm7.7,1.2-3.8-2.2a1.1,1.1,0,0,1-.5-.9h0l3.8,2.2A1.6,1.6,0,0,1,194,146.4Zm-4.4-7.2,2,1.2a1.6,1.6,0,0,1,.5.9h0l-2-1.1a1.1,1.1,0,0,1-.5-.9Zm3.9-5.6,4.1,2.4a1.6,1.6,0,0,1,.5.9h0l-4.1-2.4A1.1,1.1,0,0,1,193.5,133.6Zm8.5-2.1-6.9-4a1.1,1.1,0,0,1-.5-.9h0l6.9,3.9a1.1,1.1,0,0,1,.5.9Zm-3.7,9.6-8.2-4.7a1.2,1.2,0,0,1-.5-1h0l8.3,4.7a2.2,2.2,0,0,1,.5.8Zm-4,.9,5.4,3.1a1.6,1.6,0,0,1,.5.9h0l-5.4-3.1A1.6,1.6,0,0,1,194.3,142Zm6.1-4.3,6,3.5a1.1,1.1,0,0,1,.5.9h0l-6-3.5A1.1,1.1,0,0,1,200.4,137.7Zm4-5.5h0l2.4,1.4a1.1,1.1,0,0,1,.5.9h0l-2.4-1.4a1.1,1.1,0,0,1-.5-.9Zm-15.1-8.7,2.5,1.4a1.2,1.2,0,0,1,.5,1h0l-2.5-1.4a1.6,1.6,0,0,1-.5-.9Zm.1,4,6.9,3.9a1.6,1.6,0,0,1,.5.9h0l-6.9-4a1.1,1.1,0,0,1-.5-.9Zm.1,3.9,1.6.9a1.1,1.1,0,0,1,.5.9h0l-1.6-.9A1.1,1.1,0,0,1,189.5,131.4Zm24-9.6h0l14.8,8.6a1.1,1.1,0,0,1,.5.9h-.1L214,122.8a1.2,1.2,0,0,1-.5-1Zm2.4,33.3h0l-2.4-1.4a1.6,1.6,0,0,1-.5-.9h0l2.4,1.5a1,1,0,0,1,.5.8Zm-18.3-34-7.9-4.5a1.6,1.6,0,0,1-.5-.9h0l7.9,4.6a1.1,1.1,0,0,1,.5.9Zm-5.4-10.9-6-3.5a1.1,1.1,0,0,1-.5-.9h0l6,3.6a1.1,1.1,0,0,1,.5.9Zm-6.5-.4,2.5,1.4a1.1,1.1,0,0,1,.5.9h0l-2.5-1.4A1.1,1.1,0,0,1,185.7,109.8Zm18.3,7.3a1.6,1.6,0,0,1-.5-.9h0l6,3.5a2.1,2.1,0,0,1,.6,1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M238.9,205.1v-2l-.4.3v.2l-.5.4h-.2l-.7.5-65.5,37.9-.5.2v3.5l65.4-37.8C238,207.4,238.9,206.2,238.9,205.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M161.2,243.2l-.6-.3h-.2L66.9,188.8v3.3L161,246.5h.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M65.9,188.2l-1.5-.9-1-.7v2h0c-.1.9.4,1.7,1.6,2.4l.9.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M170.1,243.1a12.7,12.7,0,0,1-4.7.9H164l-1.8-.3v3.4a11.9,11.9,0,0,0,7.9-.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M63.5,183.4a3.2,3.2,0,0,0,1.4,1.4l96,55.6c2.6,1.5,7.2,1.3,10.2-.4l65.4-37.8a4.3,4.3,0,0,0,2.1-2.3,2.9,2.9,0,0,0-1.3-1.4l-96.1-55.6c-2.6-1.4-7.2-1.2-10.1.5L65.6,181.2A5.6,5.6,0,0,0,63.5,183.4Zm160.9,10.8,4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-1.4.8a1.7,1.7,0,0,1-1,.3l-.8-.2h-.1l-4.3-2.6a.8.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.6-.9l1.4-.8A1.9,1.9,0,0,1,224.4,194.2Zm-6.7-3.9,4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-1.4.8a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.3l-4.3-2.5a.8.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.5-.9l1.5-.8a1.9,1.9,0,0,1,1.8-.1Zm-6.6-3.9,4.4,2.6a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-1.4.8a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.2l-4.4-2.5a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l1.4-.8a2.5,2.5,0,0,1,1.9-.1Zm-9.9-2.9,1.4-.8a2.1,2.1,0,0,1,1.9-.1l4.4,2.5a1.4,1.4,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-1.4.8a2,2,0,0,1-1.1.3l-.8-.2-4.4-2.6a.8.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.6-.9Zm-33.9-22.3,4.4,2.5c.3.1.4.4.5.7a1,1,0,0,1-.6.9l-1.4.8a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.2h0l-4.4-2.5c-.3-.2-.5-.4-.5-.7a1.1,1.1,0,0,1,.6-1l1.4-.7a1.9,1.9,0,0,1,1.9-.1Zm-1.8-.6c.1.3-.2.7-.5.9l-1.4.8a2,2,0,0,1-1.1.3l-.8-.2h0l-4.4-2.5a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l1.4-.8a2.5,2.5,0,0,1,1.9-.1l4.3,2.6a.8.8,0,0,1,.5.7Zm-30.2-15.1,1.5-.8a1.9,1.9,0,0,1,1.8-.1l4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-1.4.8a1.8,1.8,0,0,1-1,.2h-.9l-4.3-2.6a.8.8,0,0,1-.5-.7A1.2,1.2,0,0,1,135.3,145.5Zm-34.4,19.3,5.2-3a1.9,1.9,0,0,1,1.8-.1v-.3a.7.7,0,0,1,.5-.9l4.3-2.6a2,2,0,0,1,1.7-.1v-.2a1.1,1.1,0,0,1,.6-.9l4.2-2.5a2.5,2.5,0,0,1,1.7-.2h0a1,1,0,0,1,.6-.9l4.3-2.6a2.3,2.3,0,0,1,1.8-.1l.3.2h0a1.1,1.1,0,0,1,.6-.9l4.2-2.5a1.9,1.9,0,0,1,1.9-.1l4.4,2.5a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.6-.9.2.9.6v-.2a1.1,1.1,0,0,1,.6-.9l4.2-2.5a2.1,2.1,0,0,1,1.9-.1l4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.2,2.5a2,2,0,0,1-1.1.3l1,.6v-.2a1,1,0,0,1,.6-.9l4.3-2.6a2.3,2.3,0,0,1,1.8-.1l-4-2.3a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l1.4-.8a2.3,2.3,0,0,1,1.8-.1l4.4,2.6a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-1.4.8a1.7,1.7,0,0,1-1,.3l-.8-.2,4,2.4a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.2,2.6-1.1.2.9.6v-.2a1.1,1.1,0,0,1,.6-.9l4.3-2.5a1.7,1.7,0,0,1,1.8-.1l-4-2.4a.8.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l1.4-.8a1.9,1.9,0,0,1,1.8-.1l4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.5.9l-1.5.8-1,.2H155l4,2.3c.3.2.5.4.5.7a1.1,1.1,0,0,1-.6,1l-4.2,2.5a1.7,1.7,0,0,1-1,.3l1,.6v-.2a1.1,1.1,0,0,1,.6-.9l4.3-2.5a2.1,2.1,0,0,1,1.9-.1l4.3,2.5a1,1,0,0,1,.5.8c.1.3-.2.6-.5.9l-4.3,2.5-.9.3.9.5h-.1a1,1,0,0,1,.6-.9l4.3-2.6a2.5,2.5,0,0,1,1.9-.1l4.3,2.6a.8.8,0,0,1,.5.7,1.1,1.1,0,0,1-.5.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.6h-.1a1,1,0,0,1,.6-.9l4.3-2.5a1.9,1.9,0,0,1,1.9-.1l4.4,2.5a1.8,1.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.6-.9.2,1,.6v-.7a1.1,1.1,0,0,1,.6-.9l4.3-2.5a2.1,2.1,0,0,1,1.9-.1l4.1,2.5a1,1,0,0,1,.5.8c.1.3-.2.6-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3l1.1.6h-.1a1.1,1.1,0,0,1,.6-1l4.3-2.5a2.1,2.1,0,0,1,1.9-.1l4.4,2.6a1.8,1.8,0,0,1,.5.7,1.1,1.1,0,0,1-.6.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.6v-.2a1.1,1.1,0,0,1,.5-.9l4.3-2.5a2.1,2.1,0,0,1,1.9-.2l4.4,2.6a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.6a2,2,0,0,1-1.1.3l1.1.6v-.2c-.1-.3.2-.7.5-.9l4.3-2.5a1.9,1.9,0,0,1,1.9-.1l4.4,2.5a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5a1.9,1.9,0,0,1-1,.3l1,.5V193a1.1,1.1,0,0,1,.6-.9l4.2-2.5a2.1,2.1,0,0,1,1.9-.1l4.4,2.6a.8.8,0,0,1,.5.7,1.1,1.1,0,0,1-.6.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.6h0a1,1,0,0,1,.6-.9l4.2-2.6a2.5,2.5,0,0,1,1.9-.1l4.4,2.6a.8.8,0,0,1,.5.7.8.8,0,0,1-.2.5,1.7,1.7,0,0,1,1.7,0l8.1,4.6a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3h-.6a1,1,0,0,1-.6.9l-4.3,2.5a2,2,0,0,1-1.1.3h-.7v.2a1.1,1.1,0,0,1-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3h-.6a1.1,1.1,0,0,1-.6.9l-4.2,2.5a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.2h0l-5.4-3.1a1.5,1.5,0,0,1-.5.6l-2.1,1.2a1.8,1.8,0,0,1-1,.2h-.1c-.1.1-.1.3-.3.5h.1a1.8,1.8,0,0,1,1.6-.1h0l4.9,2.7a1,1,0,0,1,.5.8c0,.2-.1.5-.6.7l-2,1.2a1.8,1.8,0,0,1-1,.2h-.6l-5-2.9a.8.8,0,0,1-.4-.7.5.5,0,0,1,.3-.5H192a1.8,1.8,0,0,1-1,.2h-.6l-5-2.8a1,1,0,0,1-.4-.7.6.6,0,0,1,.1-.4l-.8.2h-.6l-5-2.8a.8.8,0,0,1-.3-1.1l.2-.2a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.3l-4.3-2.5a.8.8,0,0,1-.5-.7c0-.2,0-.3.1-.4l-.9.2-.8-.2h0l-7-4a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l5.1-2.9a2.2,2.2,0,0,1,1.8-.2.5.5,0,0,1-.2-.4,1,1,0,0,1,.6-.9l4.3-2.5.9-.3-.9-.5h0a1.1,1.1,0,0,1-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3h-.6a.6.6,0,0,1,.1.4.9.9,0,0,1-.5.8l-5.2,3.1-1,.2-.9-.2-30.3-17.5-.2-.2a.9.9,0,0,1-.3-.6,1.1,1.1,0,0,1,.6-.9l5.2-3,1-.2h0a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4.3-2.5a2,2,0,0,1,1.1-.3l-1.1-.6v.2a1.1,1.1,0,0,1-.6.9l-4.2,2.5-1.2.3h0c.2.2.3.3.3.5a1,1,0,0,1-.6.9l-5.2,3a2,2,0,0,1-1.1.3l-.8-.2-6.9-4a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.5-.9l5.2-2.9a2,2,0,0,1,1.1-.3l-1.1-.6h0a1.1,1.1,0,0,1-.5.9l-5.2,3a2,2,0,0,1-1.1.3l-.8-.2-4.3-2.5a1,1,0,0,1-.5-.8c-.1-.3.2-.7.5-.9l5.2-3a2,2,0,0,1,1.1-.2l-1.1-.7v.3a1.1,1.1,0,0,1-.5.9l-5.2,3-1.1.2H112l-4.3-2.5a.8.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.5-.9l5.2-3a2.7,2.7,0,0,1,1.2-.3l-1.3-.7v.3c.1.3-.2.6-.5.9l-5.2,2.9a2.1,2.1,0,0,1-1.1.4,1.1,1.1,0,0,1-.8-.3l-4.3-3.1c-.3-.2-.5-.4-.5-.7A1.1,1.1,0,0,1,100.9,164.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M176.5,179a1.1,1.1,0,0,1-.6.9l-4.2,2.5a2,2,0,0,1-1.1.3l.4.3a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.5a1.6,1.6,0,0,1-.9.3l.9.5h0a1.1,1.1,0,0,1,.5-.9l4.3-2.5a1.7,1.7,0,0,1,1-.3l-.3-.2a.8.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l4.3-2.6,1.1-.2-1.1-.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M187.9,202l-4.3,2.5a2,2,0,0,1-1.1.3h0l1.1.6v-.2c-.1-.4.2-.7.5-1l4.3-2.5.9-.2-.9-.6v.2A1.1,1.1,0,0,1,187.9,202Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M177.8,203l.9-.2-.9-.5a.4.4,0,0,1,.1.3C177.9,202.8,177.9,202.9,177.8,203Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M181.7,197h0a1.1,1.1,0,0,1-.5.9l-4.3,2.6a2,2,0,0,1-1.1.3h-.2l1.3.7v-.3a1.1,1.1,0,0,1,.6-.9l4.3-2.5a1.7,1.7,0,0,1,1-.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M196.6,190.7c.1.3-.2.7-.5.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l.3.2a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.6h0a1,1,0,0,1,.6-.9l4.2-2.5,1.2-.3-.5-.3c-.3-.1-.4-.4-.5-.7a1,1,0,0,1,.6-.9l4.3-2.6,1-.2-1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M209.5,199.4l-4.3,2.5a1.9,1.9,0,0,1-1,.3h.3a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5-.9.3,1,.6v-.2a1.1,1.1,0,0,1,.6-.9l4.2-2.5a2,2,0,0,1,1.1-.3l-.4-.2a1,1,0,0,1-.5-.8c-.1-.3.2-.6.5-.9L210,199a1.7,1.7,0,0,1,1-.3l-1-.5h.1A1.1,1.1,0,0,1,209.5,199.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M214.8,200.6c0-.2.1-.3.2-.5l-.8.2.6.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M216.8,202.3a1.1,1.1,0,0,1-.6.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1.1.6h-.1a1,1,0,0,1,.6-.9l4.3-2.6.9-.2-1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M142.5,159.4a1.1,1.1,0,0,1-.6.9l-4.3,2.5-.9.3.6.3a1,1,0,0,1,.5.8c.1.3-.2.7-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3h0l1.2.7c-.1,0-.1-.1-.1-.2a1.1,1.1,0,0,1,.6-.9l4.3-2.5a2,2,0,0,1,1.1-.3l-.8-.4a.8.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l4.3-2.6,1-.2-1.2-.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M189.9,186.8a1.1,1.1,0,0,1-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3l.4.2a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5c-.2.2-.6.2-.9.3l.9.5h0a1,1,0,0,1,.6-.9l4.2-2.6,1-.2-.3-.2a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4.3-2.5a2,2,0,0,1,1.1-.3l-1.1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M182.6,208.7l4.8,2.8c.3.1.4.4.5.7s-.1.2-.1.4a1.8,1.8,0,0,1,1-.2.8.8,0,0,1,.5-.7l2.1-1.2.3-.2-.9-.5a1.8,1.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l4.3-2.6.9-.2-1-.6h.1a1.1,1.1,0,0,1-.6.9l-4.3,2.5a2,2,0,0,1-1.1.3,1.1,1.1,0,0,1-.8-.2l-4.1-2.4v.3a1.1,1.1,0,0,1-.6.9l-2.4,1.4A2,2,0,0,1,182.6,208.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M183.2,182.9a1,1,0,0,1-.6.9l-4.2,2.6-1,.2.3.2c.3.2.5.4.5.7a1.1,1.1,0,0,1-.6,1l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.5h0a1.1,1.1,0,0,1,.6-.9l4.2-2.5a2.7,2.7,0,0,1,1.2-.3l-.5-.2a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4.3-2.5.9-.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M203.3,194.5a1.1,1.1,0,0,1-.5.9l-4.3,2.6a2,2,0,0,1-1.1.3l.4.2a.8.8,0,0,1,.5.7,1,1,0,0,1-.6.9l-4.3,2.6-.9.2.9.5h0a1.1,1.1,0,0,1,.6-.9l4.2-2.5a1.7,1.7,0,0,1,1-.3l-.3-.2a1.8,1.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.6-.9l4.3-2.5a2,2,0,0,1,1.1-.3l-1.1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M149.3,163.3a1.1,1.1,0,0,1-.5.9l-4.3,2.5a2,2,0,0,1-1.1.3l.7.5a.8.8,0,0,1,.5.7,1.1,1.1,0,0,1-.5.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l1,.6v-.2a1,1,0,0,1,.6-.9l4.3-2.6,1-.2-.5-.3a.8.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l4.3-2.6,1-.2-1.2-.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M135.7,155.5c.1.3-.2.6-.5.9l-4.3,2.5a1.7,1.7,0,0,1-1,.3l.6.3a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5-.9.3,1.1.6c-.1,0-.1-.1-.1-.2a1.1,1.1,0,0,1,.6-.9l4.3-2.5c.2-.2.5-.2.9-.3l-.7-.3a2.2,2.2,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4.3-2.5a1.7,1.7,0,0,1,1-.3l-1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M163.4,193.6a1,1,0,0,1,.6-.9l4.3-2.6a1.8,1.8,0,0,1,1-.2l-1-.6h0a1.1,1.1,0,0,1-.6.9l-4.2,2.5a2,2,0,0,1-1.1.3h-.2l1.3.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M156.7,189.6a1.1,1.1,0,0,1,.6-.9l4.3-2.5c.2-.2.5-.2.9-.3l-1-.5h0a1.1,1.1,0,0,1-.5.9l-4.3,2.6a1.7,1.7,0,0,1-1,.3h-.2l1.3.8C156.8,189.9,156.7,189.8,156.7,189.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M169.2,176.1l-4.2,2.5a1.7,1.7,0,0,1-1,.3h.3a1.4,1.4,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4.3,2.5a2,2,0,0,1-1.1.3h0l1.1.6h0a1.1,1.1,0,0,1,.5-.9l4.3-2.6a1.7,1.7,0,0,1,1.2-.2l-.5-.3a.8.8,0,0,1-.5-.7,1,1,0,0,1,.6-.9l4.3-2.6.9-.2-.9-.5h0A1.1,1.1,0,0,1,169.2,176.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M123.7,169.4l4.2-2.6a3,3,0,0,1,1.3-.2l-1.3-.8v.2a1,1,0,0,1-.6.9l-4.2,2.5-1.1.4,1.1.6h0A1.1,1.1,0,0,1,123.7,169.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M163.1,171.2a1,1,0,0,1-.6.9l-4.3,2.6a1.7,1.7,0,0,1-1,.3l.3.2c.3.2.5.4.5.7a1.2,1.2,0,0,1-.5,1l-4.3,2.5a1.9,1.9,0,0,1-1,.3l1,.5V180a1.1,1.1,0,0,1,.6-.9l4.3-2.5a1.7,1.7,0,0,1,1-.3h-.3a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4.3-2.5a1.7,1.7,0,0,1,1-.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M149.9,185.8a1.1,1.1,0,0,1,.6-.9l4.3-2.5a2,2,0,0,1,1.1-.3l-1.1-.7v.2a1,1,0,0,1-.6.9l-4.2,2.6a2,2,0,0,1-1.1.3h-.1l1.2.6C149.9,186,149.9,185.9,149.9,185.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M130.4,173.2l4.3-2.5.9-.3-.9-.5h0a1,1,0,0,1-.6.9l-4.2,2.6-1.1.2,1,.6V174A1.6,1.6,0,0,1,130.4,173.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M143.2,181.9a1,1,0,0,1,.6-.9l4.3-2.6.9-.2-.9-.6v.2a1.1,1.1,0,0,1-.6.9l-4.2,2.5a1.7,1.7,0,0,1-1,.3l1,.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M156.2,167.3a1,1,0,0,1-.6.9l-4.2,2.6-1,.2.4.3a.8.8,0,0,1,.5.7,1.1,1.1,0,0,1-.5.9l-4.3,2.6-1.1.2h0l1.1.7v-.2a1.1,1.1,0,0,1,.6-.9l4.3-2.5a2.7,2.7,0,0,1,1.2-.3l-.5-.3a.8.8,0,0,1-.5-.7,1.1,1.1,0,0,1,.6-.9l4.2-2.5.9-.3-1-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M238.5,201.9A5.8,5.8,0,0,1,237,203h0l-65.4,37.9c-3.3,1.9-8.3,2.1-11.2.4l-96-55.6-1-.7a2.8,2.8,0,0,0,1.5,1.5l96,55.5c2.6,1.5,7.2,1.3,10.2-.4l65.4-37.9A5.8,5.8,0,0,0,238.5,201.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M101.5,165.6l4.2,2.5h.1a.8.8,0,0,0,.8-.1l5.1-3-4.2-2.4h-.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M100.9,166.4l4.3,2.5a1.1,1.1,0,0,0,.8.3,2.1,2.1,0,0,0,1.1-.4l5.2-2.9c.3-.3.6-.6.5-.9v-.3l1.3.7-1.2.3-5.2,3a1.1,1.1,0,0,0-.5.9.8.8,0,0,0,.5.7l4.3,2.5h.8l1.1-.2,5.2-3a1.1,1.1,0,0,0,.5-.9v-.3l1.1.7a2,2,0,0,0-1.1.2l-5.2,3c-.3.2-.6.6-.5.9a1,1,0,0,0,.5.8l4.3,2.5.8.2a2,2,0,0,0,1.1-.3l5.2-3a1.1,1.1,0,0,0,.5-.9h0l1.1.6a2,2,0,0,0-1.1.3l-5.2,2.9a1.1,1.1,0,0,0-.5.9,1,1,0,0,0,.5.8l6.9,4,.8.2a2,2,0,0,0,1.1-.3l5.2-3a1,1,0,0,0,.6-.9c0-.2-.1-.3-.3-.5h0a2.7,2.7,0,0,0,1.2-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9v-.2l1.1.6a2,2,0,0,0-1.1.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8h0l-1,.2-5.2,3a1.1,1.1,0,0,0-.6.9.9.9,0,0,0,.3.6l.2.2L161,201.1l.9.2,1-.2,5.2-3.1a.9.9,0,0,0,.5-.8.6.6,0,0,0-.1-.4h.6a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9h0l.9.5a1.6,1.6,0,0,0-.9.3l-4.3,2.5a1,1,0,0,0-.6.9.5.5,0,0,0,.2.4,2.2,2.2,0,0,0-1.8.2l-5.1,2.9a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l7,4h0l.8.2.9-.2c-.1.1-.1.2-.1.4a.8.8,0,0,0,.5.7l4.3,2.5a1.1,1.1,0,0,0,.8.3,2,2,0,0,0,1.1-.3.8.8,0,0,0-.1,1.1l.2.2,5,2.8h.6l.8-.2a.6.6,0,0,0-.1.4,1,1,0,0,0,.4.7l5,2.8h.6a1.8,1.8,0,0,0,1-.2h.1a.5.5,0,0,0-.3.5.8.8,0,0,0,.4.7l5,2.9h.6a1.8,1.8,0,0,0,1-.2l2-1.2c.5-.2.6-.5.6-.7a1,1,0,0,0-.5-.8l-4.9-2.7h0a1.8,1.8,0,0,0-1.6.1h-.1c.2-.2.2-.4.3-.5h.1a1.8,1.8,0,0,0,1-.2l2.1-1.2a1.5,1.5,0,0,0,.5-.6l5.4,3.1h0a1.1,1.1,0,0,0,.8.2,2,2,0,0,0,1.1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9h.6a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9v-.2h.7a2,2,0,0,0,1.1-.3l4.3-2.5a1,1,0,0,0,.6-.9h.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-8.1-4.6a1.7,1.7,0,0,0-1.7,0,.8.8,0,0,0,.2-.5.8.8,0,0,0-.5-.7l-4.4-2.6a2.5,2.5,0,0,0-1.9.1l-4.2,2.6a1,1,0,0,0-.6.9h0l-1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4.4-2.6a2.1,2.1,0,0,0-1.9.1l-4.2,2.5a1.1,1.1,0,0,0-.6.9v.2l-1-.5a1.9,1.9,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-4.4-2.5a1.9,1.9,0,0,0-1.9.1l-4.3,2.5c-.3.2-.6.6-.5.9v.2l-1.1-.6a2,2,0,0,0,1.1-.3l4.3-2.6a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4.4-2.6a2.1,2.1,0,0,0-1.9.2l-4.3,2.5a1.1,1.1,0,0,0-.5.9v.2l-1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9,1.8,1.8,0,0,0-.5-.7l-4.4-2.6a2.1,2.1,0,0,0-1.9.1l-4.3,2.5a1.1,1.1,0,0,0-.6,1h.1l-1.1-.6a2,2,0,0,0,1.1-.3l4.3-2.5c.3-.3.6-.6.5-.9a1,1,0,0,0-.5-.8l-4.3-2.5a2.1,2.1,0,0,0-1.9.1l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2l-1-.6.9-.2,4.3-2.6a1,1,0,0,0,.6-.9,1.8,1.8,0,0,0-.5-.7l-4.4-2.5a1.9,1.9,0,0,0-1.9.1l-4.3,2.5a1,1,0,0,0-.6.9h.1l-1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9.8.8,0,0,0-.5-.7l-4.3-2.6a2.5,2.5,0,0,0-1.9.1l-4.3,2.6a1,1,0,0,0-.6.9h.1l-.9-.5.9-.3,4.3-2.5c.3-.3.6-.6.5-.9a1,1,0,0,0-.5-.8l-4.3-2.5a2.1,2.1,0,0,0-1.9.1l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2l-1-.6a1.7,1.7,0,0,0,1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-1c0-.3-.2-.5-.5-.7l-4-2.3h.8l1-.2,1.5-.8a1.1,1.1,0,0,0,.5-.9,1,1,0,0,0-.5-.8l-4.4-2.5a1.9,1.9,0,0,0-1.8.1l-1.4.8a1,1,0,0,0-.6.9.8.8,0,0,0,.5.7l4,2.4a1.7,1.7,0,0,0-1.8.1l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2l-.9-.6,1.1-.2,4.2-2.6a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4-2.4.8.2a1.7,1.7,0,0,0,1-.3l1.4-.8a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4.4-2.6a2.3,2.3,0,0,0-1.8.1l-1.4.8a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l4,2.3a2.3,2.3,0,0,0-1.8.1l-4.3,2.6a1,1,0,0,0-.6.9v.2l-1-.6a2,2,0,0,0,1.1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-4.4-2.5a2.1,2.1,0,0,0-1.9.1l-4.2,2.5a1.1,1.1,0,0,0-.6.9v.2l-.9-.6.9-.2,4.3-2.6a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4.4-2.5a1.9,1.9,0,0,0-1.9.1l-4.2,2.5a1.1,1.1,0,0,0-.6.9h0l-.3-.2a2.3,2.3,0,0,0-1.8.1l-4.3,2.6a1,1,0,0,0-.6.9h0a2.5,2.5,0,0,0-1.7.2l-4.2,2.5a1.1,1.1,0,0,0-.6.9v.2a2,2,0,0,0-1.7.1l-4.3,2.6a.7.7,0,0,0-.5.9v.3a1.9,1.9,0,0,0-1.8.1l-5.2,3a1.1,1.1,0,0,0-.5.9C100.4,166,100.6,166.2,100.9,166.4Zm51.7-12h.9l4.2,2.4-1.4.8a1,1,0,0,1-.9.1l-4.2-2.5Zm-6.6-3.8a1,1,0,0,1,.9-.1l4.2,2.5-1.4.8h-.9l-4.2-2.4Zm-38.5,12,4.2,2.4-5.1,3a.8.8,0,0,1-.8.1h-.1l-4.2-2.5,5.1-3Zm6.6-3.9,12.7,7.4-4.3,2.5a.8.8,0,0,1-.8.1h0L109,161.3l4.2-2.5A1,1,0,0,1,114.1,158.7Zm6.5-3.7,9.2,5.3-4.2,2.5a.8.8,0,0,1-.8.1h-.1l-9.2-5.3,4.3-2.5A.8.8,0,0,1,120.6,155Zm6.6-3.8,7.4,4.3-4.2,2.5a1,1,0,0,1-.9.2h0l-7.5-4.3,4.3-2.5a1,1,0,0,1,.9-.2Zm1.8-.9,4.3-2.5c.2-.1.7-.2.8-.1l4.3,2.5-4.3,2.5a1,1,0,0,1-.9.1Zm11.8,1.3,4.3,2.4-4.3,2.6h-.9l-4.2-2.4,4.3-2.5a.8.8,0,0,1,.8-.1Zm6.8,3.8,4.2,2.5-4.3,2.5a1,1,0,0,1-.9.1l-4.2-2.5,4.3-2.5a1,1,0,0,1,.9-.1Zm6.6,3.8,4.2,2.5-4.2,2.5a1,1,0,0,1-.9.1h0l-4.3-2.5,4.3-2.5Zm1.5,6.6,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.4-4.2,2.6H160Zm11.9,1.2,4.2,2.5-4.2,2.5a1,1,0,0,1-.9.1h0l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1Zm6.7,3.9,4.2,2.5-4.2,2.5a1,1,0,0,1-.9.1l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1Zm6.8,3.9,4.2,2.4-4.2,2.5a1,1,0,0,1-.9.2h0l-4.2-2.4,4.2-2.5a1,1,0,0,1,.9-.2Zm6.7,3.9,4.2,2.5-4.2,2.5h-.9l-4.2-2.4,4.2-2.5A1,1,0,0,1,187.8,178.7Zm6.7,3.8,4.2,2.5-4.2,2.5a.8.8,0,0,1-.8.1h-.1l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1Zm6.7,4,4.3,2.4-4.3,2.5a1,1,0,0,1-.9.1l-4.2-2.4,4.2-2.6Zm6.7,3.8,4.3,2.4-4.3,2.6a.8.8,0,0,1-.8.1H207l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1Zm6.7,3.9,4.3,2.5-4.3,2.5a1,1,0,0,1-.9.1l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1Zm6.5,3.8,7.9,4.5-4.3,2.5a1,1,0,0,1-.9.1l-7.9-4.5,4.3-2.6Zm-3.8,10.9-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1l4.2,2.5-4.2,2.5a1.4,1.4,0,0,1-.9.1Zm-6.6,3.7h0l-9.4-5.4,4.3-2.5a.8.8,0,0,1,.8-.1l9.4,5.4-4.2,2.5c-.3.2-.7.3-.9.1Zm-6.6,3.8L191.5,209l4.2-2.5a1,1,0,0,1,.9-.1l12.7,7.4-4.3,2.5a1.4,1.4,0,0,1-.9.1Zm-13.3.8-4.6-2.6,1.9-1.1h.7l4.6,2.6-1.9,1.1Zm-6.7-3.8-4.6-2.6,2-1.2h.6l4.6,2.6-1.9,1.1Zm-6.8-4h-.1l-4.2-2.5,5.1-2.9a1,1,0,0,1,.9-.1l4.2,2.5-5.1,2.9a.8.8,0,0,1-.8.1Zm-7.4-10.7,6.9,4-5.1,2.9a1,1,0,0,1-.9.1l-6.9-3.9,5.2-3Zm-1.1-2.7-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.5-4.2,2.5Zm-7.3,4.3-29.5-17,5.6-3.2,29.9,17.2-5.1,3Zm-32.9-19h-.1l-6.8-3.9,5.1-3h.9l6.8,4-5.1,2.9Zm-9.3-5.4h-.1l-4.2-2.4,5.1-3a1,1,0,0,1,.9-.1l4.2,2.5-5.1,2.9c-.3.1-.7.2-.8.1Zm2.7-6.1,1.1-.4,4.2-2.5a1,1,0,0,0,.6-.9v-.2l1.3.8a3,3,0,0,0-1.3.2l-4.2,2.6a1,1,0,0,0-.6.9h0Zm-9.5,2.2-4.2-2.5,5.1-2.9a1,1,0,0,1,.9-.1l4.2,2.4-5.1,3a1,1,0,0,1-.9.1Zm20-10.2,4.2,2.4-4.2,2.6a1.4,1.4,0,0,1-.9.1h0l-4.3-2.4,4.3-2.5a1,1,0,0,1,.9-.2Zm-4,5.9a.8.8,0,0,1,.8-.1l4.3,2.5-4.3,2.5a1,1,0,0,1-.9.1l-4.2-2.5Zm10.8-1.9,4.2,2.4-4.2,2.6h-.9l-4.3-2.4,4.3-2.5a1,1,0,0,1,.9-.1Zm4.7.1a1,1,0,0,1-.9.1h0l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.5Zm-6.9-3.9h-.9l-4.2-2.4,4.2-2.5a1,1,0,0,1,.9-.1l4.2,2.4Zm-8.3,11.7,1.1-.2,4.2-2.6a1,1,0,0,0,.6-.9h0l.9.5a1.6,1.6,0,0,0-.9.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2Zm6.4,2.9h0l-4.3-2.4,4.3-2.6h.9l4.2,2.4-4.3,2.5c-.3.1-.7.2-.8.1Zm10.8-7,4.2,2.5-4.2,2.5a1,1,0,0,1-.9.1l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1Zm11.7,4.2a.8.8,0,0,1-.8.1h0l-4.3-2.5,4.3-2.5c.2-.1.7-.2.8-.1l4.3,2.5Zm6.7,3.9a1,1,0,0,1-.9.1l-4.2-2.4,4.3-2.6h.9l4.2,2.4Zm-14.9,6.5a1,1,0,0,1-.9.1h0l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.5Zm-.6,1.2a2,2,0,0,0,1.1-.3l4.2-2.6a1,1,0,0,0,.6-.9v-.2l1.1.7a2,2,0,0,0-1.1.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9c0,.1,0,.2.1.2l-1.2-.6Zm16.3,1-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1l4.3,2.5-4.3,2.5A1,1,0,0,1,165.2,186.4Zm11.9,1.2-4.3,2.5a1,1,0,0,1-.9.1l-4.2-2.5,4.2-2.5h.9ZM163,192a1.4,1.4,0,0,1-.9.1h0l-4.3-2.4,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.4Zm-6.9-3.9c-.1.2-.5.2-.9.1l-4.2-2.5,4.3-2.5a1.4,1.4,0,0,1,.9-.1l4.2,2.5Zm-.4,1.2a1.7,1.7,0,0,0,1-.3l4.3-2.6a1.1,1.1,0,0,0,.5-.9h0l1,.5c-.4.1-.7.1-.9.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9c0,.2.1.3.1.4l-1.3-.8Zm6.7,3.8a2,2,0,0,0,1.1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9h0l1,.6a1.8,1.8,0,0,0-1,.2l-4.3,2.6a1,1,0,0,0-.6.9c0,.1.1.1.1.2l-1.3-.7Zm15.5-7.6a1,1,0,0,1-.9.1l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.5ZM154.3,180l4.2-2.5a1,1,0,0,1,.9-.1l4.2,2.4-4.2,2.6h-.9Zm-2.5-1.4-4.2-2.5,4.2-2.5h.9l4.2,2.5-4.2,2.5Zm-9-3.2,4.2,2.4-4.2,2.6h-.9l-4.3-2.4,4.3-2.5A1,1,0,0,1,142.8,175.4Zm.5,5.8,4.2-2.5a1.1,1.1,0,0,0,.6-.9v-.2l.9.6-.9.2-4.3,2.6a1,1,0,0,0-.6.9v.2l-1-.6A2,2,0,0,0,143.3,181.2Zm41.3,8.1a1,1,0,0,1-.9.2h0l-4.3-2.4,4.3-2.6h.9l4.2,2.4Zm-6,4.8-4.2-2.4,4.2-2.6h.9l4.3,2.4-4.3,2.5a1,1,0,0,1-.9.1Zm12.7-.8h-.9l-4.3-2.4,4.3-2.5a1,1,0,0,1,.9-.1l4.2,2.4Zm6.7,3.8a1,1,0,0,1-.9.1h0l-4.2-2.5,4.2-2.5a1,1,0,0,1,.9-.1l4.2,2.5Zm6.7,3.9a1,1,0,0,1-.9.1l-4.2-2.5,4.2-2.5h.9l4.2,2.5Zm-12.7.9-4.2-2.5,4.3-2.5a.8.8,0,0,1,.8-.1l4.3,2.5-4.3,2.5a1,1,0,0,1-.9.1Zm-3.1.7a1,1,0,0,1,.9-.1L194,205l-4.2,2.5a.8.8,0,0,1-.8.1h-.1l-4.2-2.5Zm.4-1.1-.9.2-4.3,2.5c-.3.3-.6.6-.5,1v.2l-1.1-.6h0a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9v-.2Zm-10.6,1.3-.9.2c.1-.1.1-.2.1-.4a.4.4,0,0,0-.1-.3Zm4.4.8a1,1,0,0,1-.9.1l-4.2-2.4,4.2-2.6h.9l4.2,2.4Zm-1.4-5.7-4.3,2.5a1.1,1.1,0,0,0-.6.9v.3l-1.3-.7h.2a2,2,0,0,0,1.1-.3l4.3-2.6a1.1,1.1,0,0,0,.5-.9h0l1,.6-.9.2Zm17,7.8-4.2-2.4,4.3-2.6h.8l4.3,2.4-4.3,2.5a1,1,0,0,1-.9.1Zm-17.6-10.2,4.2-2.5a1,1,0,0,1,.9-.1l4.3,2.5-4.3,2.5a1.4,1.4,0,0,1-.9.1Zm-4.7-.8,4.2,2.5-4.2,2.5a1,1,0,0,1-.9.1h0l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1Zm7.4,12.5a1.1,1.1,0,0,0,.6-.9V206l4.1,2.4a1.1,1.1,0,0,0,.8.2,2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9h-.1l1,.6-.9.2-4.3,2.6a1,1,0,0,0-.6.9,1.8,1.8,0,0,0,.5.7l.9.5-.3.2-2.1,1.2a.8.8,0,0,0-.5.7,1.8,1.8,0,0,0-1,.2c0-.2.1-.3.1-.4s-.2-.6-.5-.7l-4.8-2.8a1.7,1.7,0,0,0-1.2-.1Zm10.8,7.9-4.6-2.6,1.9-1.1a.7.7,0,0,1,.6-.1l4.6,2.6-1.9,1.1Zm16.8-15.2,4.2,2.4-4.2,2.6c-.3.1-.7.2-.8.1h-.1l-4.2-2.4,4.2-2.5a1,1,0,0,1,.9-.2Zm3.6.2c-.1.2-.2.3-.2.5h0l-.6-.4Zm1.8,2.9-4.3,2.6a1,1,0,0,0-.6.9h.1l-1.1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9h-.1l1,.6Zm-5.8-4.2a1.7,1.7,0,0,0-1,.3l-4.3,2.5c-.3.3-.6.6-.5.9a1,1,0,0,0,.5.8l.4.2a2,2,0,0,0-1.1.3l-4.2,2.5a1.1,1.1,0,0,0-.6.9v.2l-1-.6.9-.3,4.3-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8h-.3a1.9,1.9,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-1H210Zm-7.7-3.5-4.3,2.5a1.1,1.1,0,0,0-.6.9,1.8,1.8,0,0,0,.5.7l.3.2a1.7,1.7,0,0,0-1,.3l-4.2,2.5a1.1,1.1,0,0,0-.6.9h0l-.9-.5.9-.2,4.3-2.6a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-.4-.2a2,2,0,0,0,1.1-.3l4.3-2.6a1.1,1.1,0,0,0,.5-.9h0l1.1.6a2,2,0,0,0-1.1.3Zm-6.7-4-4.3,2.6a1,1,0,0,0-.6.9c.1.3.2.6.5.7l.5.3-1.2.3-4.2,2.5a1,1,0,0,0-.6.9h0l-1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-.3-.2a1.7,1.7,0,0,0,1-.3l4.3-2.5c.3-.2.6-.6.5-.9v-.2l1,.6Zm-6.7-3.8-4.3,2.5a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l.3.2-1,.2-4.2,2.6a1,1,0,0,0-.6.9h0l-.9-.5c.3-.1.7-.1.9-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-.4-.2a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9v-.2l1.1.6a2.1,2.1,0,0,0-1.1.4Zm-6.7-3.9-4.3,2.5a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l.5.2a2.7,2.7,0,0,0-1.2.3l-4.2,2.5a1.1,1.1,0,0,0-.6.9h0l-1-.5a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-1c0-.3-.2-.5-.5-.7l-.3-.2,1-.2,4.2-2.6a1,1,0,0,0,.6-.9h0l.9.5Zm-6.7-3.9-4.3,2.6a1,1,0,0,0-.6.9.8.8,0,0,0,.5.7l.3.2a1.7,1.7,0,0,0-1,.3l-4.3,2.5a1.1,1.1,0,0,0-.5.9h0l-.9-.5.9-.3,4.3-2.5a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-.4-.3a2,2,0,0,0,1.1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9v-.2l1.1.7Zm-1.1-.6-4.2,2.5a1,1,0,0,1-.9.1h0l-4.3-2.5,4.3-2.5a1,1,0,0,1,.9-.1Zm-4.7-3.5-.9.2-4.3,2.6a1,1,0,0,0-.6.9.8.8,0,0,0,.5.7l.5.3a1.7,1.7,0,0,0-1.2.2l-4.3,2.6a1.1,1.1,0,0,0-.5.9h0l-1.1-.6h0a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.6-.9,1.4,1.4,0,0,0-.5-.8H164a1.7,1.7,0,0,0,1-.3l4.2-2.5a1.1,1.1,0,0,0,.6-.9h0Zm-7.6-3.6-4.3,2.5a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8h.3a1.7,1.7,0,0,0-1,.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2l-1-.5a1.9,1.9,0,0,0,1-.3l4.3-2.5c.4-.3.6-.6.5-1a.9.9,0,0,0-.5-.7l-.3-.2a1.7,1.7,0,0,0,1-.3l4.3-2.6a1,1,0,0,0,.6-.9h0l1,.6a1.7,1.7,0,0,0-1,.3Zm-6.8-3.9-4.2,2.5a1.1,1.1,0,0,0-.6.9.8.8,0,0,0,.5.7l.5.3a2.7,2.7,0,0,0-1.2.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9v.2l-1.1-.7h0l1.1-.2,4.3-2.6a1.1,1.1,0,0,0,.5-.9.8.8,0,0,0-.5-.7l-.4-.3,1-.2,4.2-2.6a1,1,0,0,0,.6-.9h0l1,.6Zm-1.2-.7-4.2,2.5a1,1,0,0,1-.9.1l-4.3-2.5L150,165a1,1,0,0,1,.9-.1Zm-5.6-3.3-4.3,2.6a1,1,0,0,0-.6.9.8.8,0,0,0,.5.7l.5.3-1,.2-4.3,2.6a1,1,0,0,0-.6.9v.2l-1-.6a1.7,1.7,0,0,0,1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9.8.8,0,0,0-.5-.7l-.7-.5a2,2,0,0,0,1.1-.3l4.3-2.5a1.1,1.1,0,0,0,.5-.9h0l1.2.7Zm-6.9-4-4.3,2.6a1,1,0,0,0-.6.9.8.8,0,0,0,.5.7l.8.4a2,2,0,0,0-1.1.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9c0,.1,0,.2.1.2l-1.2-.7h0a2,2,0,0,0,1.1-.3l4.3-2.5c.3-.2.6-.6.5-.9a1,1,0,0,0-.5-.8l-.6-.3.9-.3,4.3-2.5a1.1,1.1,0,0,0,.6-.9v-.2l1.2.7Zm-6.9-3.9-4.3,2.5a1.1,1.1,0,0,0-.6.9,2.2,2.2,0,0,0,.5.8l.7.3c-.4.1-.7.1-.9.3l-4.3,2.5a1.1,1.1,0,0,0-.6.9c0,.1,0,.2.1.2l-1.1-.6.9-.3,4.3-2.5a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-.6-.3a1.7,1.7,0,0,0,1-.3l4.3-2.5c.3-.3.6-.6.5-.9v-.2l1,.6a1.7,1.7,0,0,0-1,.3Zm59.9,61.1,4.6,2.7-1.9,1.1h-.7l-4.6-2.7,2-1.1a.6.6,0,0,1,.6,0Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M118.5,168.9l-4.2-2.4a1,1,0,0,0-.9.1l-5.1,2.9,4.2,2.5a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M125.2,172.8l-4.2-2.5a1,1,0,0,0-.9.1l-5.1,3,4.2,2.4h.1c.1.1.5,0,.8-.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M129.3,172.6l4.3-2.5-4.3-2.5a.8.8,0,0,0-.8.1l-4.3,2.5,4.2,2.5A1,1,0,0,0,129.3,172.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M140.3,173.9l-4.2-2.4h-.9l-4.3,2.6,4.3,2.4h0c.1.1.5,0,.8-.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M137.6,178l4.3,2.4h.9l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M148.6,179.3l-4.3,2.5,4.3,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5A1,1,0,0,0,148.6,179.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M155.3,183.2l-4.3,2.5,4.2,2.5c.4.1.8.1.9-.1l4.3-2.5-4.2-2.5A1.4,1.4,0,0,0,155.3,183.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M162.1,187.1l-4.3,2.5,4.3,2.4h0a1.4,1.4,0,0,0,.9-.1l4.2-2.6-4.2-2.4A1,1,0,0,0,162.1,187.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M173.9,193.4l-4.2-2.5a1,1,0,0,0-.9.1l-4.3,2.5,4.3,2.5h.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M171.2,197.3l4.3,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M182.2,198.7l-4.2,2.6,4.2,2.4a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M189,207.6a.8.8,0,0,0,.8-.1L194,205l-4.2-2.5a1,1,0,0,0-.9.1l-4.2,2.5,4.2,2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M134.1,168.4l4.3,2.4h.9l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M127.3,164.4l4.3,2.4h0a1.4,1.4,0,0,0,.9-.1l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M115.5,157.6l9.2,5.3h.1a.8.8,0,0,0,.8-.1l4.2-2.5-9.2-5.3a.8.8,0,0,0-.8.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M122,153.8l7.5,4.3h0a1,1,0,0,0,.9-.2l4.2-2.5-7.4-4.3a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M140.8,172.2l4.3,2.5a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M156.9,176l-4.2-2.5h-.9l-4.2,2.5,4.2,2.5a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M159.4,182.4l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1l-4.2,2.5,4.2,2.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M170.4,183.8l-4.3-2.5a1,1,0,0,0-.9.1l-4.2,2.5,4.2,2.5a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M171.9,185.2l-4.2,2.5,4.2,2.5a1,1,0,0,0,.9-.1l4.3-2.5-4.3-2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M183.8,191.5l-4.3-2.4h-.9l-4.2,2.6,4.2,2.4a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M186.2,197.9l4.3-2.5-4.3-2.5a1,1,0,0,0-.9.1l-4.2,2.5,4.2,2.5A1.4,1.4,0,0,0,186.2,197.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M197.2,199.3l-4.3-2.5a.8.8,0,0,0-.8.1l-4.3,2.5,4.2,2.5a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M203.9,203.1l-4.3-2.4h-.8l-4.3,2.6,4.2,2.4a1,1,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M215.8,210l-9.4-5.4a.8.8,0,0,0-.8.1l-4.3,2.5,9.4,5.4h0c.2.2.6.1.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M215.9,200.6l7.9,4.5a1,1,0,0,0,.9-.1l4.3-2.5-7.9-4.5h-.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M156.9,168.9l-4.3,2.5,4.3,2.5h0a.8.8,0,0,0,.8-.1l4.3-2.5-4.3-2.5C157.6,168.7,157.1,168.8,156.9,168.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M150.9,164.9a1,1,0,0,0-.9.1l-4.3,2.5L150,170a1,1,0,0,0,.9-.1l4.2-2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M143.1,161l-4.3,2.5,4.3,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5A1,1,0,0,0,143.1,161Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M136.2,157.1l-4.2,2.5,4.2,2.4h.9l4.2-2.6-4.2-2.4A1,1,0,0,0,136.2,157.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M163.6,172.8l-4.3,2.6,4.2,2.4a1,1,0,0,0,.9-.1l4.3-2.5-4.2-2.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M171.2,176.6a1,1,0,0,0-.9.1l-4.3,2.5,4.3,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M177,180.6l-4.3,2.5,4.3,2.5a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5A1,1,0,0,0,177,180.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M183.7,184.4l-4.3,2.6,4.3,2.4h0a1,1,0,0,0,.9-.2l4.2-2.5-4.2-2.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M190.4,188.4l-4.3,2.5,4.3,2.4h.9l4.2-2.6-4.2-2.4A1,1,0,0,0,190.4,188.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M197.1,192.2l-4.2,2.5,4.2,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5A1,1,0,0,0,197.1,192.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M203.8,196.1l-4.2,2.5,4.2,2.5a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M206.3,202.5l4.2,2.4h.1c.1.1.5,0,.8-.1l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M222.4,206.3l-4.2-2.5a1,1,0,0,0-.9.1l-4.2,2.5,4.2,2.5a1.4,1.4,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M149,161.8l4.3,2.5h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5h-.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M142.4,158l4.2,2.5a1,1,0,0,0,.9-.1l4.3-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M135.7,154.2l4.2,2.4h.9l4.3-2.6-4.3-2.4a.8.8,0,0,0-.8.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M133.2,152.8a1,1,0,0,0,.9-.1l4.3-2.5-4.3-2.5c-.1-.1-.6,0-.8.1l-4.3,2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M135.9,146.3l4.2,2.5a1,1,0,0,0,.9-.1l1.4-.8-4.3-2.4a.8.8,0,0,0-.8.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M135.3,147.1l4.3,2.6h.9a1.8,1.8,0,0,0,1-.2l1.4-.8a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-4.4-2.5a1.9,1.9,0,0,0-1.8.1l-1.5.8a1.1,1.1,0,0,0-.5.9A.9.9,0,0,0,135.3,147.1Zm2.8-1.6,4.3,2.4-1.4.8a1,1,0,0,1-.9.1l-4.2-2.5,1.4-.7a.8.8,0,0,1,.8-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M149.7,153.8l1.4-.8-4.2-2.5a1,1,0,0,0-.9.1l-1.4.8,4.2,2.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M156.3,157.6l1.4-.8-4.2-2.4h-.9l-1.4.8,4.2,2.5A1,1,0,0,0,156.3,157.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M159.3,158.3l-1.4.8,4.2,2.4a1.2,1.2,0,0,0,1-.1l1.3-.7-4.2-2.5A1,1,0,0,0,159.3,158.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M158.8,157.4l-1.4.8a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l4.4,2.5h0l.8.2a2,2,0,0,0,1.1-.3l1.4-.8c.3-.2.6-.6.5-.9a.8.8,0,0,0-.5-.7l-4.3-2.6A2.5,2.5,0,0,0,158.8,157.4Zm4.3,4a1.2,1.2,0,0,1-1,.1l-4.2-2.4,1.4-.8a1,1,0,0,1,.9-.1l4.2,2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M164.5,162.9l4.3,2.4h.9l1.3-.8-4.2-2.5a1.4,1.4,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M164,162a1.1,1.1,0,0,0-.6,1c0,.3.2.5.5.7l4.4,2.5h0a1.1,1.1,0,0,0,.8.2,2,2,0,0,0,1.1-.3l1.4-.8a1,1,0,0,0,.6-.9c-.1-.3-.2-.6-.5-.7l-4.4-2.5a1.9,1.9,0,0,0-1.9.1Zm2.8,0,4.2,2.5-1.3.8h-.9l-4.3-2.4,1.4-.8a1.4,1.4,0,0,1,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M201.7,184.3l4.3,2.5h0a1,1,0,0,0,.9-.1l1.3-.8-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M200.6,184.4a.8.8,0,0,0,.5.7l4.4,2.6.8.2a2,2,0,0,0,1.1-.3l1.4-.8a1.1,1.1,0,0,0,.6-.9,1.4,1.4,0,0,0-.5-.8l-4.4-2.5a2.1,2.1,0,0,0-1.9.1l-1.4.8A1.1,1.1,0,0,0,200.6,184.4Zm3.4-.9,4.2,2.4-1.3.8a1,1,0,0,1-.9.1h0l-4.3-2.5,1.4-.7a1,1,0,0,1,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M208.4,188.2l4.2,2.4h.9l1.4-.8-4.3-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M207.8,187.3a1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.5.8l4.4,2.5a1.1,1.1,0,0,0,.8.2,2,2,0,0,0,1.1-.3l1.4-.8a1,1,0,0,0,.6-.9.8.8,0,0,0-.5-.7l-4.4-2.6a2.5,2.5,0,0,0-1.9.1Zm2.8,0,4.3,2.5-1.4.8c-.3.1-.7.2-.8.1h-.1l-4.2-2.4,1.3-.8A1,1,0,0,1,210.6,187.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M215,192l4.2,2.5h.1a.8.8,0,0,0,.8-.1l1.4-.8-4.3-2.4h-.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M214.4,191.2a1.1,1.1,0,0,0-.5.9.8.8,0,0,0,.5.7l4.3,2.5a1.1,1.1,0,0,0,.8.3,2,2,0,0,0,1.1-.3l1.4-.8a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-4.4-2.5a1.9,1.9,0,0,0-1.8.1Zm2.8,0,4.3,2.4-1.4.8a.8.8,0,0,1-.8.1h-.1L215,192l1.4-.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M221.7,195.9l4.2,2.5a1,1,0,0,0,.9-.1l1.4-.8-4.3-2.4a.8.8,0,0,0-.8.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M221.2,195.1a1.1,1.1,0,0,0-.6.9.8.8,0,0,0,.5.7l4.3,2.6h.1l.8.2a1.7,1.7,0,0,0,1-.3l1.4-.8a1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.5-.8l-4.4-2.5a1.9,1.9,0,0,0-1.8.1Zm2.7,0,4.3,2.4-1.4.8a1,1,0,0,1-.9.1l-4.2-2.5,1.4-.7A.8.8,0,0,1,223.9,195.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M160,168.2h.9l4.2-2.6-4.2-2.4a1,1,0,0,0-.9.1l-4.3,2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M166.7,172.1h0a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1l-4.2,2.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M169.2,173.5l4.2,2.5a1,1,0,0,0,.9-.1l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M176,177.4l4.2,2.4h0a1,1,0,0,0,.9-.2l4.2-2.5-4.2-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M182.7,181.3l4.2,2.4h.9l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M189.4,185.1l4.2,2.5h.1a.8.8,0,0,0,.8-.1l4.2-2.5-4.2-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M196.1,189.1l4.2,2.4a1,1,0,0,0,.9-.1l4.3-2.5-4.3-2.4h-.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M202.8,192.9l4.2,2.5h.1a.8.8,0,0,0,.8-.1l4.3-2.6-4.3-2.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M209.5,196.8l4.2,2.5a1,1,0,0,0,.9-.1l4.3-2.5-4.3-2.5a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M109,161.3l12.7,7.4h0a.8.8,0,0,0,.8-.1l4.3-2.5-12.7-7.4a1,1,0,0,0-.9.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M209.3,213.8l-12.7-7.4a1,1,0,0,0-.9.1l-4.2,2.5,12.6,7.4a1.4,1.4,0,0,0,.9-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M183.2,206.4l-4.2-2.5a1,1,0,0,0-.9.1l-5.1,2.9,4.2,2.5h.1a.8.8,0,0,0,.8-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M134.5,178.2l-6.8-4h-.9l-5.1,3,6.8,3.9h.1c.1.1.5,0,.8-.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M163.9,201.8l6.9,3.9a1,1,0,0,0,.9-.1l5.1-2.9-6.9-4h-.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M137.6,180.1l-5.6,3.2,29.5,17h.9l5.1-3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M193,218.5l4.6,2.7h.7l1.9-1.1-4.6-2.7c-.2-.1-.5-.1-.6.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M193.4,216l-4.6-2.6h-.7l-1.9,1.1,4.6,2.6h.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M186.7,212.2l-4.6-2.6h-.6l-2,1.2,4.6,2.6h.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M197.1,213.9l-4.6-2.6a.7.7,0,0,0-.6.1l-1.9,1.1,4.6,2.6h.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M199.6,113.9l-4.1-2.4h0a1.6,1.6,0,0,0,.5.9l4.1,2.3h0A1.4,1.4,0,0,0,199.6,113.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M209.5,119.6l-6-3.5h0a1.6,1.6,0,0,0,.5.9l6.1,3.5A1.5,1.5,0,0,0,209.5,119.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M194,134.6l4.1,2.4h0a1.6,1.6,0,0,0-.5-.9l-4.1-2.4h0A1.1,1.1,0,0,0,194,134.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M200.9,138.6l6,3.5h0a1.1,1.1,0,0,0-.5-.9l-6-3.5h0A1.1,1.1,0,0,0,200.9,138.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M186.2,110.7l2.5,1.4h0a1.1,1.1,0,0,0-.5-.9l-2.5-1.4h0A1.1,1.1,0,0,0,186.2,110.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M197.1,120.2l-7.9-4.6h0a1.6,1.6,0,0,0,.5.9l7.9,4.5h0A1,1,0,0,0,197.1,120.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M189.8,124.5l2.5,1.4h0a1.2,1.2,0,0,0-.5-1l-2.5-1.4h0A1.4,1.4,0,0,0,189.8,124.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M203.1,147.8l6.8,3.9h0a1.1,1.1,0,0,0-.5-.9l-6.8-4h0A1.2,1.2,0,0,0,203.1,147.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M190,132.3l1.6.9h0a1.1,1.1,0,0,0-.5-.9l-1.6-.9h0A1.1,1.1,0,0,0,190,132.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M190.1,140.2l2,1.1h0a1.6,1.6,0,0,0-.5-.9l-2-1.2h0A1.2,1.2,0,0,0,190.1,140.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M194.8,143l5.4,3.1h0a1.6,1.6,0,0,0-.5-.9l-5.4-3.1h0A1.6,1.6,0,0,0,194.8,143Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M193.5,145.4l-3.8-2.2h0a1.1,1.1,0,0,0,.5.9l3.8,2.2h0A1.6,1.6,0,0,0,193.5,145.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M215.4,154.2l-2.4-1.5h0a1.6,1.6,0,0,0,.5.9l2.4,1.4h0A1,1,0,0,0,215.4,154.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M201.5,130.5l-6.9-3.9h0a1.1,1.1,0,0,0,.5.9l6.9,4h0A1.2,1.2,0,0,0,201.5,130.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M201.3,126.5l-12-6.9h0a1.6,1.6,0,0,0,.5.9l12,6.9h0A1.1,1.1,0,0,0,201.3,126.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M189.9,128.4l6.9,4h0a1.6,1.6,0,0,0-.5-.9l-6.9-3.9h0A1.4,1.4,0,0,0,189.9,128.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M204.9,133.1l2.4,1.4h0a1.1,1.1,0,0,0-.5-.9l-2.4-1.4h0A1.1,1.1,0,0,0,204.9,133.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M214,122.8l14.7,8.5h.1a1.1,1.1,0,0,0-.5-.9l-14.8-8.6h0A1.2,1.2,0,0,0,214,122.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M197.9,140.1l-8.3-4.7h0a1.2,1.2,0,0,0,.5,1l8.2,4.7v-.2A2,2,0,0,0,197.9,140.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M191.7,109.3l-6-3.6h0a1.1,1.1,0,0,0,.5.9l6,3.5h0A1,1,0,0,0,191.7,109.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-6"
          d="M186.8,146.1l7,4.1h0a1.1,1.1,0,0,0-.5-.9l-7-4h0A1.4,1.4,0,0,0,186.8,146.1Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Group_12" data-name="Group 12">
        <g class="cls-7">
          <g id="PaperBack">
            <path
              class="cls-6"
              d="M56.1,132.4a30.5,30.5,0,0,0-7.5,3.1l-13.1,7.7c8.4-4.9,16.5-9.3,19.4-10.4Z"
              transform="translate(0 0.1)"
            />
            <path class="cls-6" d="M12,156.8l-.2.3L24,149.8Z" transform="translate(0 0.1)" />
            <path
              class="cls-6"
              d="M126.9,41.6a63.7,63.7,0,0,1,2.6-9.5,53.7,53.7,0,0,0-3,11.3c0-.1.1-.2.1-.3S126.8,42.2,126.9,41.6Z"
              transform="translate(0 0.1)"
            />
            <path
              class="cls-8"
              d="M127.9,41.8l-.3,1.5c-1,3.6-.6,26.3-.6,26.6s-.1,55.5-.1,62-2,13.9-5.6,21.7a40.5,40.5,0,0,1-4.8,7.6l14.3,8.4,1.7.8.8.5h.2l.3.2h.2v.3c4.3,3.3,6.7,9.3,6.7,17v.3a.5.5,0,0,1,0,.5V198c0,7.6,2.5,13.2,7.1,15.8s10.6,2,17.2-1.8c13.8-8,25.1-27.5,25.1-43.5V86.1c0-16.6,11.7-37,26.2-45.3,4.7-2.8,9.3-4,13.4-3.6L201,20.3,171,2.9h0a.6.6,0,0,1-.6,0C166.6.4,159.8-1,149.6,6.5,132.6,19.1,129.1,36.2,127.9,41.8Z"
              transform="translate(0 0.1)"
            />
            <path
              class="cls-8"
              d="M44.7,175.8l31.2,18.1.3-.4,36.6-21.3c5.1-2.9,10.1-4.1,14.4-3.6l-27.3-16-.7-.2h-.5L67.5,134.1a16.1,16.1,0,0,0-12.2-.4C49,136,18.1,154.5,12.9,157.6l31.6,18.2Z"
              transform="translate(0 0.1)"
            />
            <g>
              <path
                class="cls-1"
                d="M99.2,152.4h-.5L67.5,134.1a16.1,16.1,0,0,0-12.2-.4C49,136,18.1,154.5,12.9,157.6l31.6,18.2h.2l31.2,18.1.3-.4,36.6-21.3c5.1-2.9,10.1-4.1,14.4-3.6l-27.3-16Z"
                transform="translate(0 0.1)"
              />
              <path
                class="cls-1"
                d="M171,2.9h0a.6.6,0,0,1-.6,0C166.6.4,159.8-1,149.6,6.5c-17,12.5-20.5,29.6-21.7,35.2l-.3,1.5c-1,3.6-.6,26.3-.6,26.6s-.1,55.5-.1,62-2,13.9-5.6,21.7a40.5,40.5,0,0,1-4.8,7.6l14.3,8.4,1.7.8.8.5h.2l.3.2h.2v.3c4.3,3.3,6.7,9.3,6.7,17v.3a.5.5,0,0,1,0,.5v8.8c0,7.6,2.5,13.2,7.1,15.8s10.6,2,17.2-1.8c13.8-8,25.1-27.5,25.1-43.5V86.1c0-16.6,11.7-37,26.2-45.3,4.7-2.8,9.3-4,13.4-3.6L201,20.3Z"
                transform="translate(0 0.1)"
              />
              <g>
                <path
                  class="cls-1"
                  d="M171,2.9h0a.6.6,0,0,1-.6,0C166.6.4,159.8-1,149.6,6.5c-17,12.5-20.5,29.6-21.7,35.2l-.3,1.5c-1,3.6-.6,26.3-.6,26.6s-.1,55.5-.1,62-2,13.9-5.6,21.7a40.5,40.5,0,0,1-4.8,7.6l14.3,8.4,1.7.8.8.5h.2l.3.2h.2v.3c4.3,3.3,6.7,9.3,6.7,17v.3a.5.5,0,0,1,0,.5v8.8c0,7.6,2.5,13.2,7.1,15.8s10.6,2,17.2-1.8c13.8-8,25.1-27.5,25.1-43.5V86.1c0-16.6,11.7-37,26.2-45.3,4.7-2.8,9.3-4,13.4-3.6L201,20.3Z"
                  transform="translate(0 0.1)"
                />
                <path
                  class="cls-1"
                  d="M99.2,152.4h-.5L67.5,134.1a16.1,16.1,0,0,0-12.2-.4C49,136,18.1,154.5,12.9,157.6l31.6,18.2h.2l31.2,18.1.3-.4,36.6-21.3c5.1-2.9,10.1-4.1,14.4-3.6l-27.3-16Z"
                  transform="translate(0 0.1)"
                />
                <path
                  class="cls-2"
                  d="M234.9,39l-2-1.2L201.5,19.4h0L170.9,1.7h-.6C166.1-.7,159.1-1.7,149,5.8a55.5,55.5,0,0,0-19.5,26.3,63.7,63.7,0,0,0-2.6,9.5q-.2.9-.3,1.5c0,.1-.1.2-.1.3-.9,4.4-.6,25.6-.5,26.5s-.1,55.5-.1,62-2,13.6-5.6,21.3a40.7,40.7,0,0,1-4.6,7.5l-15.4-8.9h-.1l-.6-.2h-.5L68,133.6a16.4,16.4,0,0,0-11.9-.9l-1.2.4c-2.9,1.1-11,5.5-19.4,10.4L24,150.1l-12.2,7.3h-.1c-.2.1-.3.2-.3.4s.1.3.3.4l32.4,18.7h.1l32.1,18.6h.5l.6-.3,17-9.9,20.9,12.1h.3l29.6,17.2,1.7,1.2a15.8,15.8,0,0,0,7.3,1.8,17.4,17.4,0,0,0,4.5-.6,17.1,17.1,0,0,0,3.8-1.3L166,214c14.3-8.3,25.9-28.5,25.9-45.1V86.1c0-10.7,5-22.9,12.4-32.2.1-.2,5.2-6.1,5.3-6h.2l26.4,10.4,1.3.4a.9.9,0,0,0,.9-.9S239.1,43.7,234.9,39ZM112.8,172.2,76.2,193.5l-.3.4L44.7,175.8h-.2L12.9,157.6c5.2-3.1,36.1-21.6,42.4-23.9a16.1,16.1,0,0,1,12.2.4l31.2,18.1h.5l.7.2,27.3,16C122.9,168.1,117.9,169.3,112.8,172.2ZM216.4,40.8c-14.5,8.3-26.2,28.7-26.2,45.3v82.5c0,16-11.3,35.5-25.1,43.5-6.6,3.8-12.7,4.4-17.2,1.8s-7.1-8.2-7.1-15.8v-8.8a.5.5,0,0,0,0-.5v-.3c0-7.7-2.4-13.7-6.7-17v-.3h-.2l-.3-.2h-.2l-.8-.5-1.7-.8-14.3-8.4a40.5,40.5,0,0,0,4.8-7.6c3.6-7.8,5.5-15.1,5.6-21.7s.1-62,.1-62-.4-23,.6-26.6l.3-1.5c1.2-5.6,4.7-22.7,21.7-35.2,10.2-7.5,17-6.1,20.8-3.6a.6.6,0,0,0,.6,0h0l30,17.4,28.8,16.9C225.7,36.8,221.1,38,216.4,40.8Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          id="Text"
          class="cls-5"
          d="M156.7,106.3l-5.4-3.1a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l5.4,3.2a2.1,2.1,0,0,1,1,1.7C157.6,106.3,157.2,106.6,156.7,106.3Zm11.5,6.7-8-4.7a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l8,4.6a2.2,2.2,0,0,1,1,1.8C169.1,113,168.7,113.3,168.2,113ZM156.1,85.7l-10.3-5.9a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7L156,83.3a2.1,2.1,0,0,1,.9,1.8C156.9,85.7,156.6,86,156.1,85.7Zm-6.8,6.2L145.9,90a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l3.4,1.9a2.1,2.1,0,0,1,1,1.7C150.2,91.9,149.8,92.2,149.3,91.9Zm-1.1,9.5-2.1-1.2a1.9,1.9,0,0,1-1-1.7c0-.7.4-1,.9-.7l2.2,1.2a2,2,0,0,1,.9,1.7c.1.7-.3,1.1-.9.7Zm13.7-2.2-9-5.3a1.9,1.9,0,0,1-1-1.7c0-.7.3-1,.9-.7l9,5.2a2.2,2.2,0,0,1,1,1.8C162.8,99.2,162.3,99.5,161.9,99.2Zm-.3-5.3-15.8-9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l15.8,9.1a2.2,2.2,0,0,1,.9,1.7C162.4,93.9,162.1,94.2,161.6,93.9Zm-6.6,6.4-9-5.2a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l9,5.3a1.9,1.9,0,0,1,1,1.7c0,.7-.3,1-.9.7Zm13.7,2.9-3.3-1.9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l3.3,1.9a2.2,2.2,0,0,1,1,1.8c0,.6-.4.9-.9.7Zm-9.3-25.7L154,74.3a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l5.4,3.1a2.2,2.2,0,0,1,1,1.8c0,.7-.4.9-.9.7Zm12.9,7.4-8-4.6a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l8,4.6a2.2,2.2,0,0,1,1,1.8c0,.7-.4,1-.9.7Zm-15.6,21.4-5.4-3.1a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l5.4,3.2a2.1,2.1,0,0,1,1,1.7c0,.7-.4,1-.9.7Zm11.5,6.7-8-4.7a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l8,4.6a2.2,2.2,0,0,1,1,1.8c0,.7-.4,1-.9.7ZM144.6,74l-3.4-1.9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l3.4,1.9a2.2,2.2,0,0,1,1,1.8c0,.7-.4.9-.9.7Zm11.5,11.7-10.3-5.9a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7L156,83.3a2.1,2.1,0,0,1,.9,1.8c0,.6-.3.9-.8.6Zm-6.8,6.2L145.9,90a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l3.4,1.9a2.1,2.1,0,0,1,1,1.7c0,.7-.4,1-.9.7Zm22.9,33.5-9.1-5.2a2.1,2.1,0,0,1-.9-1.8c0-.7.3-.9.8-.7l9.1,5.3a2.1,2.1,0,0,1,1,1.7C173.1,125.4,172.7,125.7,172.2,125.4Zm-24-24-2.1-1.2a1.9,1.9,0,0,1-1-1.7c0-.7.4-1,.9-.7l2.2,1.2a2,2,0,0,1,.9,1.7C149.2,101.4,148.8,101.8,148.2,101.4Zm.7,10.6-2.7-1.6a2,2,0,0,1-.9-1.7c0-.7.3-1,.8-.7l2.7,1.6a1.9,1.9,0,0,1,1,1.7C149.9,112,149.5,112.3,148.9,112Zm10.6,6.1-7.1-4.1a2,2,0,0,1-.9-1.7c0-.7.3-1,.8-.7l7.1,4.1a2,2,0,0,1,.9,1.7C160.3,118,159.9,118.4,159.5,118.1Zm-8,.4-5.2-2.9a2.1,2.1,0,0,1-.9-1.8c0-.7.3-.9.8-.7l5.2,3a2,2,0,0,1,.9,1.7C152.3,118.4,152,118.8,151.5,118.5Zm10.4-19.3-9-5.3a1.9,1.9,0,0,1-1-1.7c0-.7.3-1,.9-.7l9,5.2a2.2,2.2,0,0,1,1,1.8C162.8,99.2,162.3,99.5,161.9,99.2Zm-.3-5.3-15.8-9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l15.8,9.1a2.2,2.2,0,0,1,.9,1.7C162.4,93.9,162.1,94.2,161.6,93.9Zm-6.6,6.4-9-5.2a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l9,5.3a1.9,1.9,0,0,1,1,1.7c0,.7-.3,1-.9.7Zm13.7,2.9-3.3-1.9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l3.3,1.9a2.2,2.2,0,0,1,1,1.8c0,.6-.4.9-.9.7ZM157,111.6l-10.8-6.3a2.1,2.1,0,0,1-.9-1.8c0-.7.3-.9.8-.7l10.8,6.3a2.2,2.2,0,0,1,1,1.8c0,.7-.3,1-.9.7Zm-7.9-40.1-8-4.6a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l8,4.6a2.1,2.1,0,0,1,1,1.7C150,71.5,149.5,71.8,149.1,71.5Zm2.1,51.9-9.2-5.3a1.9,1.9,0,0,1-1-1.7c0-.7.4-1,.9-.7l9.2,5.3a2.1,2.1,0,0,1,1,1.7C152.1,123.4,151.6,123.7,151.2,123.4Zm4.3,31.5-5.4-3.1a2.2,2.2,0,0,1-1-1.8c0-.7.4-1,.9-.7l5.4,3.2a2,2,0,0,1,.9,1.7C156.3,154.9,155.9,155.2,155.5,154.9Zm11.4,6.6-8-4.6a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l8,4.6a2.1,2.1,0,0,1,1,1.7C167.8,161.5,167.4,161.8,166.9,161.5Zm-12-27.3-10.3-5.9a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l10.3,5.9a2,2,0,0,1,.9,1.7C155.7,134.2,155.3,134.6,154.9,134.2Zm-6.8,6.3-3.4-1.9a2.2,2.2,0,0,1-1-1.8c0-.7.4-.9.9-.7l3.4,2a2,2,0,0,1,.9,1.7C148.9,140.4,148.6,140.8,148.1,140.5ZM147,150l-2.2-1.2a2.1,2.1,0,0,1-.9-1.8c0-.7.3-.9.9-.7l2.1,1.3a1.9,1.9,0,0,1,1,1.7c0,.7-.4,1-.9.7Zm13.6-2.3-9.1-5.2a2,2,0,0,1-.9-1.7c0-.7.3-1,.9-.7l9,5.2a2.1,2.1,0,0,1,1,1.7C161.5,147.7,161.1,148,160.6,147.7Zm-.3-5.2-15.7-9.1a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l15.8,9.1a2,2,0,0,1,.9,1.7C161.2,142.5,160.8,142.8,160.3,142.5Zm-6.5,6.4-9-5.3a1.9,1.9,0,0,1-1-1.7c0-.7.3-1,.9-.7l9,5.2a2.2,2.2,0,0,1,1,1.8C154.7,148.9,154.2,149.1,153.8,148.9Zm13.7,2.8-3.3-2a2.1,2.1,0,0,1-1-1.7c0-.7.4-1,.9-.7l3.3,1.9a2.2,2.2,0,0,1,1,1.8c0,.7-.5,1-.9.7Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Bars">
        <g id="Group_19" data-name="Group 19">
          <g id="Group_20" data-name="Group 20">
            <g id="Group_21" data-name="Group 21">
              <g id="Group_22" data-name="Group 22">
                <path
                  id="Vector_167"
                  data-name="Vector 167"
                  class="cls-5"
                  d="M226.2,255.4V224.6l-10-5.8v30.9Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_168"
                  data-name="Vector 168"
                  class="cls-3"
                  d="M226.2,224.6l10-5.8v30.9l-10,5.7Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_169"
                  data-name="Vector 169"
                  class="cls-4"
                  d="M226.2,255.4V224.6l-10-5.8v30.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="Group_23" data-name="Group 23">
                <path
                  id="Vector_170"
                  data-name="Vector 170"
                  class="cls-4"
                  d="M204.9,267.9V250.5l-10-5.7v17.3Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_171"
                  data-name="Vector 171"
                  class="cls-3"
                  d="M204.9,250.5l10.1-5.7v17.3l-10.1,5.8Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_172"
                  data-name="Vector 172"
                  class="cls-5"
                  d="M194.9,244.8l10-5.9,10.1,5.9-10.1,5.7Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="Group_24" data-name="Group 24">
                <path
                  id="Vector_173"
                  data-name="Vector 173"
                  class="cls-4"
                  d="M247.5,243.3V200.8l-10.1-5.7v42.4Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_174"
                  data-name="Vector 174"
                  class="cls-3"
                  d="M247.5,200.8l10-5.7v42.4l-10,5.8Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_175"
                  data-name="Vector 175"
                  class="cls-5"
                  d="M237.4,195.1l10.1-5.9,10,5.9-10,5.7Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
            <path
              id="Vector_176"
              data-name="Vector 176"
              class="cls-5"
              d="M216.2,218.8l10-5.8,10,5.8-10,5.8Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="Programmer">
        <g id="Group_25" data-name="Group 25">
          <g id="Group_26" data-name="Group 26">
            <path
              id="Vector_177"
              data-name="Vector 177"
              class="cls-9"
              d="M50.2,140.6l-1.9,3.8a7.4,7.4,0,0,0-.8,2.9l-.8,13H44.2L43,145.6a5.7,5.7,0,0,1,.1-1.3l1.3-7.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_178"
              data-name="Vector 178"
              class="cls-10"
              d="M47.9,209.7s-2.4-1.3-3.9.6-3.7,6.3-3.8,9.2,2.4,2.8,3.8,2.1,5.6-6.8,5.8-7.9a4.5,4.5,0,0,0-.7-3.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_179"
              data-name="Vector 179"
              class="cls-9"
              d="M48.5,209.1v2.5a1.7,1.7,0,0,1-.7,1.4,2.5,2.5,0,0,1-1.9.2c-1.8-.2-2-.8-2.1-3.4S48.5,209.1,48.5,209.1Z"
              transform="translate(0 0.1)"
            />
            <g id="Group_27" data-name="Group 27">
              <path
                id="Vector_180"
                data-name="Vector 180"
                class="cls-10"
                d="M38.9,204.7s-2.5-1.2-4,.7-3.7,6.2-3.8,9.2,2.4,2.8,3.8,2.1,5.6-6.8,5.8-8a3.5,3.5,0,0,0-.7-3.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_181"
                data-name="Vector 181"
                class="cls-9"
                d="M39.4,204.2l.2,2.5a1.7,1.7,0,0,1-.7,1.4,3.2,3.2,0,0,1-1.9.3c-1.9-.3-2-.9-2.2-3.5S39.4,204.2,39.4,204.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_182"
                data-name="Vector 182"
                class="cls-5"
                d="M61.5,157c-.8-11.9-12.9,1.8-12.9,1.8L40.3,167l-7.6,8.2a8,8,0,0,0-1.9,5.9l3.1,23.1a2.3,2.3,0,0,0,2.3,2h1.1a2.9,2.9,0,0,0,2.5-3l-.5-21.6L55,172.2S62.2,169,61.5,157Z"
                transform="translate(0 0.1)"
              />
            </g>
            <path
              id="Vector_183"
              data-name="Vector 183"
              class="cls-5"
              d="M70.5,161.6c-.7-12-12.9,1.7-12.9,1.7l-8.3,8.2-7.5,8.2a7.3,7.3,0,0,0-1.9,6L43,208.8a2.3,2.3,0,0,0,2.3,1.9h1.1a2.9,2.9,0,0,0,2.5-3L48.3,186l15.8-9.5C64.1,176.6,71.3,173.5,70.5,161.6Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_184"
              data-name="Vector 184"
              class="cls-3"
              d="M71.3,149.3a27.8,27.8,0,0,0,5-1.1c-1.3-13.3-4.7-18.4-4.7-18.4-.9-1.9-3.2-4.5-8.2-6.6-2.4-.9-9.1-2.3-11.6-.2a3.5,3.5,0,0,0-.5.8c-1.8,2.1-6.6,8-8.8,13.5a13.2,13.2,0,0,0,6.7,5.4A89,89,0,0,1,46.1,157c-4.4,15,25.5,14.6,25.2,8.9S71.1,154.8,71.3,149.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_185"
              data-name="Vector 185"
              class="cls-5"
              d="M66.3,128.1c-.5,1.9-3,2.9-5.5,2.3s-4.2-2.8-3.8-4.6,2.9-2.9,5.5-2.3S66.8,126.3,66.3,128.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_186"
              data-name="Vector 186"
              class="cls-5"
              d="M62.4,130.9a5,5,0,0,1-1.7-.2,5.9,5.9,0,0,1-3.2-1.9,3.5,3.5,0,0,1-.8-3.2c.5-2.1,3.2-3.2,5.9-2.5a6.3,6.3,0,0,1,3.3,2,3.9,3.9,0,0,1,.8,3.1C66.3,129.9,64.5,130.9,62.4,130.9ZM61,123.7c-1.8,0-3.2.8-3.5,2.1a2.7,2.7,0,0,0,.6,2.4,4.6,4.6,0,0,0,2.8,1.7c2.3.6,4.5-.3,5-1.9a2.6,2.6,0,0,0-.7-2.4,5.7,5.7,0,0,0-2.8-1.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_187"
              data-name="Vector 187"
              class="cls-3"
              d="M59.6,122.8a18.2,18.2,0,0,1,0,3.3c-.1.9,3.1,1.8,4,1s.4-1.7.7-4.8S59.6,122.8,59.6,122.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_188"
              data-name="Vector 188"
              class="cls-3"
              d="M64.3,122.3s-.8,2.9-4.7,4v-2.6Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_189"
              data-name="Vector 189"
              class="cls-9"
              d="M66,120.2a6.6,6.6,0,1,0-.1.2C65.9,120.3,66,120.3,66,120.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_190"
              data-name="Vector 190"
              class="cls-5"
              d="M61.5,116.9a22,22,0,0,1-6.7,1.7c-2.7,0-2.1-2.3-2.1-2.3l8.1-1.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_191"
              data-name="Vector 191"
              class="cls-5"
              d="M54.1,117.4a11.7,11.7,0,0,1,6.4-.9,4.2,4.2,0,0,1,1.8,1.1.8.8,0,0,0,.6.4c.5.2,1.4-2.1,2.4-2.2s1.7.7.9,2.1-.6,2.8-.1,3,4.5-2.9.9-10.1-12.9-3.3-14.3-1.9-1.6,1.4-2.7.2S48.3,119.5,54.1,117.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_192"
              data-name="Vector 192"
              class="cls-9"
              d="M67.2,149.2v3.4a2.4,2.4,0,0,1-.7,1.6L55.4,164.4l1.3,1.9,14.6-10.6a3,3,0,0,0,1.2-2.1l1-4.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_193"
              data-name="Vector 193"
              class="cls-5"
              d="M66.6,136.2c-.6,3.4-1.1,6.9-1.4,10.4a2.4,2.4,0,0,0,1.4,2.1Z"
              transform="translate(0 0.1)"
            />
            <g id="Group_28" data-name="Group 28">
              <path
                id="Vector_194"
                data-name="Vector 194"
                class="cls-5"
                d="M63.7,171.4l-2.4-.3-15.9-9.2a1.9,1.9,0,0,0-1.9.1l-11.3,6.5-1.4-.2v1.4c0,.3,0,.4.3.5L49,180.6a2.3,2.3,0,0,0,2,0l12.2-7.1c.4-.2.5-.4.5-.7Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_195"
                data-name="Vector 195"
                class="cls-5"
                d="M51.8,165.6l-1.1-.6H38.3l-6.1,3.5-1.4-.2v1.4c0,.3,0,.4.3.5L49,180.6a2,2,0,0,0,1.1.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_196"
                data-name="Vector 196"
                class="cls-5"
                d="M31.4,168.4h-.6v1.4c0,.3,0,.4.3.5l.4.2v-2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_197"
                data-name="Vector 197"
                class="cls-5"
                d="M49.2,180.8a2.5,2.5,0,0,0,1.7-.1v-2.5H49.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_198"
                data-name="Vector 198"
                class="cls-5"
                d="M49,179.2,31.1,168.8c-.5-.2-.5-.8.1-1.1l12.2-7a2,2,0,0,1,2-.1L63.3,171c.5.3.4.8-.2,1.1l-12.2,7.1A2.1,2.1,0,0,1,49,179.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_199"
                data-name="Vector 199"
                class="cls-5"
                d="M48.7,177.6,33.8,169c-.4-.2-.4-.7.1-1l6.6-3.7a1.8,1.8,0,0,1,1.6-.1l15,8.7c.4.2.3.7-.2,1l-6.5,3.7A2.5,2.5,0,0,1,48.7,177.6Z"
                transform="translate(0 0.1)"
              />
            </g>
            <path
              id="Vector_200"
              data-name="Vector 200"
              class="cls-9"
              d="M44.1,160.3l-.2,1.2a6.9,6.9,0,0,0,.1,3.2l.2,1.1a1.3,1.3,0,0,0,1.2,1.2.8.8,0,0,0,1-.7l.3-2.7s.7.9,1,.9-.4-2.6-1.2-4.2S44.1,160.3,44.1,160.3Z"
              transform="translate(0 0.1)"
            />
            <g id="Group_29" data-name="Group 29">
              <path
                id="Vector_201"
                data-name="Vector 201"
                class="cls-5"
                d="M48.4,180.2l-1.5-1.9L31.1,169a2.1,2.1,0,0,1-1-1.7v-13l-.9-1.2.9-.5c.1-.1.3,0,.6.1l17.9,10.4a2.1,2.1,0,0,1,.9,1.8V179a.9.9,0,0,1-.3.7Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_202"
                data-name="Vector 202"
                class="cls-5"
                d="M37.5,172.7l-1.1-.6-6.3-10.7v-7.1l-.9-1.2.9-.5c.1-.1.3,0,.6.1l17.9,10.4a2.7,2.7,0,0,1,.7.8Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_203"
                data-name="Vector 203"
                class="cls-5"
                d="M29.7,153.6l-.5-.5.9-.5c.1-.2.3-.1.6,0l.4.3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_204"
                data-name="Vector 204"
                class="cls-5"
                d="M48.8,163.2a2.2,2.2,0,0,1,.8,1.5l-1.7,1.1-.9-1.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_205"
                data-name="Vector 205"
                class="cls-5"
                d="M47.8,163.5,29.9,153.1c-.5-.2-.9,0-.9.7v14.1a2.1,2.1,0,0,0,.9,1.8l17.9,10.5c.5.2.9,0,.9-.7V165.3A2.1,2.1,0,0,0,47.8,163.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <path
              id="Vector_206"
              data-name="Vector 206"
              class="cls-9"
              d="M56.7,166.3l-.3.7a4.1,4.1,0,0,1-1.6,1.6L53,169.7a1.7,1.7,0,0,1-1.8.1h-.1a1,1,0,0,1-.3-1.4l.2-.2,1.9-1.9s-1.1.8-1.3.5,1-1.4,1.9-1.4a4.6,4.6,0,0,0,1.9-.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_207"
              data-name="Vector 207"
              class="cls-5"
              d="M49.1,142.7,50.2,132l-2.5,10.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_208"
              data-name="Vector 208"
              class="cls-5"
              d="M57.1,121.6l-1.8-.5a3.9,3.9,0,0,0,2.1,1.7c1.3.4,1.5-.7,1.5-.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <path
            id="Vector_209"
            data-name="Vector 209"
            class="cls-5"
            d="M66.8,118.6a1.1,1.1,0,0,1-1,1.1,1.1,1.1,0,0,1-1.1-1.1,1.1,1.1,0,0,1,1.1-1A1.1,1.1,0,0,1,66.8,118.6Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
      <g id="Graph">
        <g id="Group_30" data-name="Group 30">
          <path
            id="Vector_210"
            data-name="Vector 210"
            class="cls-5"
            d="M93.4,263.3a16.1,16.1,0,0,1-14.2,0c-4-2.3-4-6,0-8.2a15.5,15.5,0,0,1,14.2,0C97.3,257.3,97.3,261,93.4,263.3Z"
            transform="translate(0 0.1)"
          />
          <g id="Group_31" data-name="Group 31">
            <g id="Group_32" data-name="Group 32">
              <path
                id="Vector_211"
                data-name="Vector 211"
                class="cls-3"
                d="M67.6,247.3h7.8a7.2,7.2,0,0,1,2.5-2.1,18.5,18.5,0,0,1,15.6-.6l4.6-4.4h7.2l-1.1-.7c-10-5.7-26-5.7-35.9,0a19.4,19.4,0,0,0-4.5,3.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_212"
                data-name="Vector 212"
                class="cls-3"
                d="M105.3,229.2v11.3H98.1V229.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_213"
                data-name="Vector 213"
                class="cls-3"
                d="M93.5,233.5v11.3l4.6-4.4V229.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_214"
                data-name="Vector 214"
                class="cls-3"
                d="M75.4,236.1v11.3L85.7,239l7.9,5.8V233.5l-7.3-3.6-10.5,3.2C75.2,233.3,75.4,236.1,75.4,236.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_215"
                data-name="Vector 215"
                class="cls-3"
                d="M67.6,236v11.3h7.8V236.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_216"
                data-name="Vector 216"
                class="cls-3"
                d="M63.8,232v11.3l3.8,4V236Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_217"
                data-name="Vector 217"
                class="cls-4"
                d="M67.6,236h7.8a7.2,7.2,0,0,1,2.5-2.1c4.2-2.5,11-2.7,15.6-.6l4.6-4.4h7.2l-1.1-.7c-10-5.8-26-5.8-35.9,0a17,17,0,0,0-4.5,3.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="Group_33" data-name="Group 33">
              <path
                id="Vector_218"
                data-name="Vector 218"
                class="cls-5"
                d="M95.9,234.8v10.4l6.7-1.6s-.4-6.1-.5-6.3Z"
                transform="translate(0 0.1)"
              />
              <g id="Group_34" data-name="Group 34">
                <path
                  id="Vector_219"
                  data-name="Vector 219"
                  class="cls-3"
                  d="M90.8,245.2v11.4l.7.7,4.8-2.7s-.7-8.6-.8-8.8Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_220"
                  data-name="Vector 220"
                  class="cls-3"
                  d="M111.7,250.4V238.3l-5.2,4.1H100l-4.1,3.8A6.5,6.5,0,0,1,98,249l-6.7,4.3v3.3h-.6l.6.6v7.5a36.6,36.6,0,0,0,12.9-4C109.1,257.8,111.6,254.1,111.7,250.4Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_221"
                  data-name="Vector 221"
                  class="cls-4"
                  d="M100,231l-4.1,3.8c3.4,2.7,2.9,6.5-1.2,8.9a13.8,13.8,0,0,1-4,1.5l4.2,4.6-3.7,3.4a34.6,34.6,0,0,0,13-4c8.5-4.9,9.6-12.4,3.5-18.1Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
            <g id="Group_35" data-name="Group 35">
              <path
                id="Vector_222"
                data-name="Vector 222"
                class="cls-3"
                d="M87.5,257.1h-.3v-3.5l-22.4-13L61,239v11.4c0,3.7,2.5,7.4,7.4,10.3s12,4.4,18.8,4.2l4.1-3.8Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_223"
                data-name="Vector 223"
                class="cls-3"
                d="M91.3,249.7V261l-4.1,3.9V253.6Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_224"
                data-name="Vector 224"
                class="cls-4"
                d="M91.3,249.7l-3.8-4a16.9,16.9,0,0,1-9.6-2c-2.7-1.5-3.9-3.7-3.4-5.7l-8.9-.2-3.4-3.7c-3,5.2-1,11,6.1,15.1,5.1,3,12,4.5,18.8,4.3Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Dots_2" data-name="Dots 2">
        <g id="Group_36" data-name="Group 36">
          <g id="Group_37" data-name="Group 37">
            <path
              id="Vector_227"
              data-name="Vector 227"
              class="cls-5"
              d="M202.2,59.2,179,45.8a1.7,1.7,0,0,0-1.2-.1L175.5,47l1.6.6v17a4.4,4.4,0,0,0,1.9,3.6l22.3,12.9v2l2.3-1.3a2,2,0,0,0,.6-1.5V62.8A4.7,4.7,0,0,0,202.2,59.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_228"
              data-name="Vector 228"
              class="cls-3"
              d="M200,83,176.7,69.5a4.2,4.2,0,0,1-1.9-3.5V48.5c0-1.4.9-2,1.9-1.4L200,60.6a4.2,4.2,0,0,1,1.9,3.5V81.5C201.8,82.9,200.9,83.5,200,83Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="Group_38" data-name="Group 38">
            <path
              id="Vector_229"
              data-name="Vector 229"
              class="cls-5"
              d="M184.5,63.5c0,1.1-.7,1.4-1.6.9a3.7,3.7,0,0,1-1.6-2.7c0-1.1.7-1.4,1.6-.9A3.2,3.2,0,0,1,184.5,63.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_230"
              data-name="Vector 230"
              class="cls-5"
              d="M189.3,66.2c0,1.1-.7,1.4-1.6.9a3.7,3.7,0,0,1-1.6-2.7c0-1.1.7-1.4,1.6-.9A3.7,3.7,0,0,1,189.3,66.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_231"
              data-name="Vector 231"
              class="cls-5"
              d="M194,69c0,1.1-.7,1.4-1.6.9a3.7,3.7,0,0,1-1.6-2.7c0-1.1.7-1.4,1.6-.9A3.2,3.2,0,0,1,194,69Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="Dots_1" data-name="Dots 1">
        <g id="Group_39" data-name="Group 39">
          <g id="Group_40" data-name="Group 40">
            <path
              id="Vector_232"
              data-name="Vector 232"
              class="cls-5"
              d="M89,32.7,66.2,19.6a1,1,0,0,0-1.2-.1l-2.2,1.2,1.6.6V38a4.1,4.1,0,0,0,1.8,3.5L88,54.1V56l2.3-1.3a1.5,1.5,0,0,0,.6-1.5V36.3A5.2,5.2,0,0,0,89,32.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_233"
              data-name="Vector 233"
              class="cls-3"
              d="M86.7,56,63.9,42.8a4.4,4.4,0,0,1-1.8-3.5v-17c0-1.4.8-2,1.8-1.4L86.7,34a4.8,4.8,0,0,1,1.9,3.5v17C88.6,55.9,87.8,56.5,86.7,56Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="Group_41" data-name="Group 41">
            <path
              id="Vector_234"
              data-name="Vector 234"
              class="cls-5"
              d="M71.6,36.9c0,1-.7,1.4-1.6.9a3.7,3.7,0,0,1-1.6-2.7c0-1,.7-1.4,1.6-.9A3.7,3.7,0,0,1,71.6,36.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_235"
              data-name="Vector 235"
              class="cls-5"
              d="M76.2,39.6c0,1-.7,1.4-1.6.9a3.6,3.6,0,0,1-1.5-2.7c0-1,.7-1.4,1.5-.9A3.7,3.7,0,0,1,76.2,39.6Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_236"
              data-name="Vector 236"
              class="cls-5"
              d="M80.9,42.3c0,1-.7,1.4-1.6.9a3.6,3.6,0,0,1-1.5-2.7c0-1,.7-1.4,1.5-.9A3.7,3.7,0,0,1,80.9,42.3Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      id="Confetti-4"
      class="cls-5"
      d="M32.4,66.9A5.7,5.7,0,1,1,38,61.1h0a5.6,5.6,0,0,1-5.5,5.7Zm0-9.6a4,4,0,1,0,3.9,4.1v-.2a3.8,3.8,0,0,0-3.9-3.9Z"
      transform="translate(0 0.1)"
    />
    <path
      id="Confetti-3"
      class="cls-11"
      d="M228.7,8.6A4.9,4.9,0,0,1,219,10a3.3,3.3,0,0,1,0-1.4,4.7,4.7,0,0,1,4.7-4.9h.2a4.7,4.7,0,0,1,4.8,4.6Z"
      transform="translate(0 0.1)"
    />
    <g id="Confetti-1">
      <g id="Vector_237" data-name="Vector 237">
        <path
          class="cls-6"
          d="M270.7,145.3l-.5-.2a1,1,0,0,1-.5-.6l-.6-2.2a1.1,1.1,0,0,1,.8-1.3l6.7-1.7h.8l.5.6.5,2.3a1,1,0,0,1-.5,1.2h-.2l-6.8,1.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M276.9,140.3l.6,2.2-6.8,1.8-.6-2.3,6.8-1.7m0-2h-.5l-6.8,1.8a2,2,0,0,0-1.4,2.4l.6,2.3a1.6,1.6,0,0,0,.9,1.2,1.7,1.7,0,0,0,1,.3h.5l6.8-1.7a2,2,0,0,0,1.4-2.5l-.6-2.2a1.6,1.6,0,0,0-.9-1.2,1.7,1.7,0,0,0-1-.3Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Vector_238" data-name="Vector 238">
        <path
          class="cls-6"
          d="M267.2,148.8h-.5a.7.7,0,0,1-.4-.6l-.6-2.4a1,1,0,0,1,.5-1.2h.2l6.8-1.8h.7l.5.6.6,2.4a1.2,1.2,0,0,1-.7,1.3l-6.8,1.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M273.4,143.7l.6,2.4-6.8,1.7-.6-2.4,6.8-1.7m0-2h-.5l-6.8,1.7a2,2,0,0,0-1.4,2.4l.6,2.4a1.8,1.8,0,0,0,.9,1.2,1.7,1.7,0,0,0,1,.3h.5l6.8-1.8a2,2,0,0,0,1.5-2.4h0l-.7-2.4a1.6,1.6,0,0,0-.9-1.2,1.7,1.7,0,0,0-1-.3Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Vector_239" data-name="Vector 239">
        <path
          class="cls-6"
          d="M263.8,151.9h-.5l-.5-.6-.6-2.3a1,1,0,0,1,.8-1.2h0l6.7-1.7h.3l.5.2a1,1,0,0,1,.5.6l.5,2.2a1,1,0,0,1-.6,1.3h-.1l-6.8,1.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M270,146.9l.6,2.3-6.8,1.7-.6-2.2,6.8-1.8m0-2h-.5l-6.8,1.7a1.9,1.9,0,0,0-1.4,2.4h0l.6,2.2a1.6,1.6,0,0,0,.9,1.2,1.7,1.7,0,0,0,1,.3h.5l6.8-1.8a2,2,0,0,0,1.4-2.4l-.6-2.2a1.6,1.6,0,0,0-.9-1.2A1.7,1.7,0,0,0,270,144.9Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Vector_240" data-name="Vector 240">
        <path
          class="cls-6"
          d="M260.3,155.3h-.5a1.5,1.5,0,0,1-.5-.6l-.6-2.3a1,1,0,0,1,.7-1.2l6.8-1.8h.8a1,1,0,0,1,.4.7l.6,2.2a1,1,0,0,1-.5,1.2h-.2l-6.8,1.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M266.5,150.3l.5,2.3-6.7,1.7-.6-2.3,6.8-1.7m0-2H266l-6.8,1.7a1.8,1.8,0,0,0-1.4,2.3h0l.5,2.3a2,2,0,0,0,1,1.2,1.7,1.7,0,0,0,1,.3h.5l6.7-1.7a2,2,0,0,0,1.5-2.4h0l-.6-2.3a2.7,2.7,0,0,0-.9-1.2,1.7,1.7,0,0,0-1-.3Z"
          transform="translate(0 0.1)"
        />
      </g>
    </g>
    <path
      id="Confetti-2"
      class="cls-12"
      d="M265.5,70.6l-6.1-12.4,12.4-6,6,12.4Zm-2.4-11.1,3.6,7.4,7.4-3.6-3.6-7.4Z"
      transform="translate(0 0.1)"
    />
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    docs() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-docs",
            toggleActions: this.toggleConfig,
            start: "center 60%",
          },
          defaults: {
            duration: 2,
          },
        })
        .add("docs")
        .from(
          "#docscover",
          {
            duration: 2,
            x: 300,
            y: -300,
            ease: "circ",
          },
          "docs"
        )
        .from(
          "#Confetti-1, #Confetti-2, #Confetti-3, #Confetti-4",
          {
            duration: 2,
            rotation: 360,
            y: -100,
            stagger: 0.1,
            ease: "elastic(1.75, 0.3)",
          },
          "docs"
        );
    },
  },
  mounted() {
    this.docs();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
}

.cls-11,
.cls-2,
.cls-3 {
  fill: #0e1e25;
}

.cls-10,
.cls-12,
.cls-3,
.cls-4,
.cls-5,
.cls-9 {
  stroke: #0e1e25;
}

.cls-10,
.cls-11,
.cls-12,
.cls-3,
.cls-4,
.cls-5,
.cls-9 {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cls-4,
.cls-8 {
  fill: #ffad43;
}

.cls-12,
.cls-5,
.cls-6 {
  fill: #fff;
}

.cls-7 {
  clip-path: url(#docscover);
}

.cls-9 {
  fill: #caa677;
}

.cls-10 {
  fill: #2d3b41;
}

.cls-11 {
  stroke: #fff;
}

.cls-12 {
  stroke-width: 2px;
}
</style>